import React, { useState, useEffect, useRef, useMemo } from "react";
import Paper_negative from "../images/Paper Negative.svg";
import Paper_plus from "../images/Paper Plus.svg";
import arrow from "../images/arrow.png";
import axios from "axios";
import { baseURL, server_API } from "../config";
import { server_django_api } from "../config";
import { useNavigate, useLocation, Link } from "react-router-dom";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import robo from "../images/robo.svg";
import { TailSpin } from "react-loader-spinner";
import { FaInfoCircle } from "react-icons/fa";
import Copyright from "../components/Copyright";
import Select from "react-select";
import { IoMdArrowBack } from "react-icons/io";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import delete_black from "../images/Delete_black.png";
import "react-quill/dist/quill.bubble.css";
import { IoMdClose } from "react-icons/io";
import CreatableSelect from "react-select/creatable";
import { useSelector } from "react-redux";
import { selectCid } from "../features/companyid";
import { useDispatch } from "react-redux";
import { selectUuid, updateUserId, userId } from "../features/userid";
import share_whatsapp from '../images/whatsapp icon.svg'
import { EmailIcon, EmailShareButton, FacebookShareButton, LinkedinShareButton, TwitterShareButton, WhatsappIcon, WhatsappShareButton } from 'react-share';
import share_fb from '../images/share_fb.png'
import success from '../images/success.png'
import share_linkedin from '../images/share_linkedin.png'
import share_mail from '../images/share_mail.png'
import share_copy from '../images/copy.png'
import share_x from '../images/share_x.png'
import axiosInstance from "../axiosInstance";
import AiLogo from "../images/Logo_north.png"
import HackerRankLogo from "../images/hackerRank.svg"
import CoderbyteLogo from "../images/coderbyte.svg"
import { MdOutlineDateRange } from "react-icons/md";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import OpenJob from "../components/modal/NewJob/OpenJob";
import Slider from "../components/ui/Slider";
import { getCurrencySymbol, formatSalary } from "../utils/currencyUtils";
import { formatISODate, formatDateToShortMonth } from "../utils/dateUtils";

// UK: default time/dates to GB (Europe/London) timezone
const GB_TIMEZONE = "Europe/London";

const NewJobs = () => {
  const [admin, setAdmin] = useState(false);
  const [open, setOpen] = useState(false);
  const [editor, setEditor] = useState(false);
  const [manager, setManager] = useState("");
  const [viewer, setViewer] = useState(false);
  const [prompt, setPrompt] = useState("");
  const [active, setActive] = useState(false);
  const [inactive, setInactive] = useState(false);
  const [techWeight, setTechWeight] = useState(0);
  const [companyCountryCode, setCompanyCountryCode] = useState("IN"); // Default
  const [includeAiQuestions, setIncludeAiQuestions] = useState(false)
  const [includeTechnicalQuestions, setIncludeTechnicalQuestions] = useState(false)
  const [tab, setTab] = useState(0);
  const [title, setTitle] = useState("");
  const [language, setLanguage] = useState("EN");
  const [manualtrigger, setManualTrigger] = useState(false)
  const [jdSum, setJdSum] = useState("");
  const [diffLanguage, setDiffLanguage] = useState(false)
  const [recruiter, setRecuiter] = useState("");
  const [additionalRecruitersAndHrms, setAdditionalRecruitersAndHrms] = useState({
    additionalRecruiters: [],
    additionalHrms: []
  });
  const [postedSucessfully, setPostedSucessfully] = useState(false)
  const [questionSaveLoader, setQuestionSaveLoader] = useState(false)
  const [skip, setSkip] = useState(false)
  const [questions, setQuestions] = useState([]);
  const joblocation = useLocation()
  const [numQuestions, setNumQuestions] = useState(2);
  const [jid, setJid] = useState(localStorage.getItem("jid"));
  const [qid, setQid] = useState("");
  const [jtype, setType] = useState("");
  const [noOfPositions, setNoOfPositions] = useState("");
  const [department, setDepartment] = useState("");
  const [closingDate, setClosingDate] = useState("");
  const [lda, setLda] = useState("");
  const [loader, setLoader] = useState(false);
  const [experience, setExperience] = useState("");
  const [maxExp, setMaxExp] = useState("");
  const [salaryFrom, setSalaryFrom] = useState("");
  const [salaryTo, setSalaryTo] = useState("");
  const [grade, setGrade] = useState("");
  const [location, setLocation] = useState("");
  const [ws, setWs] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [description, setDescription] = useState("");
  const [privilege, setPrivilege] = useState("");
  const [requirements, setRequirements] = useState("");
  const [formattedAllUsers, setFormattedAllUsers] = useState([]);
  const [skills, setSkills] = useState("");
  const [aiSkills, setAiSkills] = useState([]);
  const [singleSkill, setSingleSingle] = useState("");
  const [resCom, setResCom] = useState(0);
  const [showAIDropdown, setShowAIDropdown] = useState(false);
  const [aiLoading, setAiLoading] = useState(false);
  const [skipTech, setSkipTech] = useState(false);
  const [genAiLoader, setGenAiLoader] = useState(false);
  const [intScore, setIntScore] = useState(0);
  const [vaScore, setVAScore] = useState(0);
  const [departments, setDepartments] = useState([]);
  const [activeGrades, setActiveGrades] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [recruiters, setRecruiters] = useState([]);
  const [openPopup, setOpenPopup] = useState(false);
  const [total, setTotal] = useState(0);
  const [openPrompt, setOpenPrompt] = useState(false);
  const [flag, setFlag] = useState(false);
  const [rem1, setRem1] = useState(172800000);
  const [rem2, setRem2] = useState(172800000);
  const [locationValues, setLocationValues] = useState([]);
  const [aboutUs, setAboutUs] = useState("");
  const [settingsVisible, setSettingsVisible] = useState(false)
  const [languageVisible, setLanguageVisible] = useState(false)
  const [salaryformated, setSalaryFormated] = useState(false);
  const cid = useSelector(selectCid);
  const [experienceFormated, setExperienceFormated] = useState(false);
  const [jobdetails, setJobdetails] = useState({})
  const isPublished = useMemo(() => {
    return jobdetails && jobdetails.jobstatus && ["open", "paused", "closed"].includes(jobdetails.jobstatus.toLowerCase());
  }, [jobdetails]);
  const [isSalaryVisible, setIsSalaryVisible] = useState(true);
  const [recruiterid, setRecruiterId] = useState("")
  const [minimumSalaryError, setMinimumSalaryError] = useState(false)
  const utcDate = new Date().toISOString();
  const [saveas, setSaveAs] = useState(joblocation.state?.saveas)
  console.log(isSalaryVisible)
  const [includeHackerrank, setIncludeHackerrank] = useState(false);
  const [activeSection, setActiveSection] = useState("both");
  const [aiComplete, setAiComplete] = useState(false);
  const [hackerrankComplete, setHackerrankComplete] = useState(false);
  const [testOptions, setTestOptions] = useState([])
  const [selectedOption, setSelectedOption] = useState(null);
  const [inviteValidFrom, setInviteValidFrom] = useState("");
  const [inviteValidTo, setInviteValidTo] = useState("");
  const [hackerrankEnabled, setHackerRankEnabled] = useState(false)
  const [coderbyteEnabled, setCoderbyteEnabled] = useState(false);
  const [coderbyteComplete, setCoderbyteComplete] = useState(false);
  const [coderbyteOptions, setCoderbyteOptions] = useState([]);
  const [coderbyteError, setCoderbyteError] = useState("");
  const [selectedCoderbyteOption, setSelectedCoderbyteOption] = useState(null);
  const [coderbyteInviteValidFrom, setCoderbyteInviteValidFrom] = useState("");
  const [coderbyteInviteValidTo, setCoderbyteInviteValidTo] = useState("");
  const [dateFocused, setDateFocused] = useState(false);
  const [manualTriggerEnabled, setManualTriggerEnabled] = useState(false)
  const [showConfirm, setShowConfirm] = useState(false);
  const [activeEmployeesSameGrade, setActiveEmployeesSameGrade] = useState("");
  const [minSalarySameGrade, setMinSalarySameGrade] = useState("");
  const [maxSalarySameGrade, setMaxSalarySameGrade] = useState("");
  const [positionType, setPositionType] = useState("");
  const [hasAiCalling, setHasAiCalling] = useState(false);
  const [newPositionComments, setNewPositionComments] = useState("");
  const [replacementEmployeeName, setReplacementEmployeeName] = useState("");
  const [replacementEmployeeCode, setReplacementEmployeeCode] = useState("");
  const [replacementEmployeeLocation, setReplacementEmployeeLocation] = useState("");
  const [replacementEmployeeDesignation, setReplacementEmployeeDesignation] = useState("");
  const [fromAcfl, setFromAcfl] = useState(false);
  const [minDob, setMinDob] = useState("");
  const [minEducation, setMinEducation] = useState("");
  const [hasApproverFlow, setHasApproverFlow] = useState(false);
  const [trigger, setTrigger] = useState(jobdetails.resume_threshold || 55);
  const [showApprovalModal, setShowApprovalModal] = useState(false);
  const [selectedApprover, setSelectedApprover] = useState(null);
  const [jobApprovers, setJobApprovers] = useState([]);
  const [approvalLoading, setApprovalLoading] = useState(false);
  const [customLocations, setCustomLocations] = useState([]);
  const [isEverestIms, setIsEverestIms] = useState(false);
  const [isSocketAI, setIsSocketAI] = useState(false);
  const [requiredSkillsList, setRequiredSkillsList] = useState([{ skill: "", minExp: "" }]);
  const [ctcBuffer, setCtcBuffer] = useState("");
  const [aiCalling, setAiCalling] = useState(false);
  const isNewUi = true;
  const handleConfirmDeleteAll = (confirmed) => {
    setShowConfirm(false);
    if (confirmed) {
      setQuestions([]);
      setSkipTech(true);
      setQid("")
      setTechWeight(0)
    }
  };
  useEffect(() => {
    if (jid) {
      axiosInstance
        .get(`${server_API}/v2/job/get/${jid}/${cid}`)
        .then((response) => {
          setJobdetails(response.data)
          setRecuiter(response.data.assignrecruiter);
          setManager(response.data.assignhiringmanager);
          setAdditionalRecruitersAndHrms({ additionalRecruiters: (response.data.additional_recruiters || []).map((item) => formattedAllUsers.find((user) => user.value === item)), additionalHrms: (response.data.additional_hrms || []).map((item) => formattedAllUsers.find((user) => user.value === item)) });
          setDescription(response.data.jobdescription);
          setTitle(response.data.profilename);
          setResCom(response.data.resumecompatibility);
          setJdSum(response.data.jdsummary);
          setIntScore(response.data.aiscore);
          setVAScore(response.data.voiceanalysisscore);
          setNoOfPositions(response.data.positionnumber);
          setAiCalling(response.data.aicalling || false);
          setManualTrigger(response.data.manual_trigger || false);
          setTrigger(response.data.resume_threshold || 55);
          let works = response.data.workstyle;
          if (works == "On-Site") {
            setAdmin(true);
          } else if (works == "Hybrid") {
            setEditor(true);
          } else if (works == "Remote") {
            setViewer(true);
          }
          setWs(response.data.workstyle);
          setDepartment(response.data.department);
          setGrade(response.data.grade || "");
          salaryFromFunc(response.data.salaryfrom);
          salaryToFunc(response.data.salaryto);
          setType(response.data.jobtype);
          let exp = response.data.experience;
          setExperience(exp.split(" ")[0]);
          setMaxExp(exp.split(" ")[2]);
          let locValues = response.data["location:"].split(",");
          // console.log(locValues, "locValues");
          setLocationValues(locValues);
          let locObject = [];
          locValues.forEach((v) => {
            var singleObj = {};
            singleObj["label"] = v;
            singleObj["value"] = v;
            locObject.push(singleObj);
            return;
          });
          // console.log(locObject, "locObject");
          setLocation(locObject);
          setLda(response.data.applicationlastdate);
          if (response.data.preferredlanguage) {
            setLanguage(response.data.preferredlanguage);
          }
          setQid(response.data.questionid);
          if (response.data.resumecompatibility) {
            setResCom(response.data.resumecompatibility);
          } else {
            setResCom("0");
          }
          setVAScore(response.data.voiceanalysisscore);
          setIntScore(response.data.aiscore);
          setTechWeight(response.data.technicalweight);
          setRem1(response.data.firstreminder);
          setRem2(response.data.finalreminder);
          setMinDob(response.data.min_dob || "");
          setMinEducation(response.data.min_education || "");
          setActiveEmployeesSameGrade(response.data.acfl_detail?.active_employees_same_grade || "");
          setMinSalarySameGrade(response.data.acfl_detail?.min_salary_same_grade || "");
          setMaxSalarySameGrade(response.data.acfl_detail?.max_salary_same_grade || "");
          setPositionType(response.data.position_type || "");
          setNewPositionComments(response.data.new_position_comments || "");
          setReplacementEmployeeName(response.data.acfl_detail?.replacement_employee_name || "");
          setReplacementEmployeeCode(response.data.acfl_detail?.replacement_employee_code || "");
          setReplacementEmployeeLocation(response.data.acfl_detail?.replacement_employee_location || "");
          setReplacementEmployeeDesignation(response.data.acfl_detail?.replacement_employee_designation || "");
          setRequiredSkillsList(response.data.required_skills?.length > 0 ? response.data.required_skills : [{ skill: "", minExp: "" }]);
          setCtcBuffer(response.data.ctc_buffer_percent || "");
          if (response.data.hackerrank_enabled) {
            setHackerrankComplete(true);
            setSelectedOption({
              value: response.data.hackerrank_test_id,
              label: response.data.hackerrank_test_name,
            });
            if (response.data.invited_valid_from) {
              setInviteValidFrom(new Date(response.data.invited_valid_from));
            }
            if (response.data.invited_valid_to) {
              setInviteValidTo(new Date(response.data.invited_valid_to));
            }
          }
          if (response.data.coderbyte_enabled) {
            setCoderbyteComplete(true);
            setSelectedCoderbyteOption({
              value: response.data.coderbyte_test_id,
              label: response.data.coderbyte_test_name,
              url: response.data.coderbyte_test_url,
            });
            if (response.data.invited_valid_from) {
              setCoderbyteInviteValidFrom(new Date(response.data.invited_valid_from));
            }
            if (response.data.invited_valid_to) {
              setCoderbyteInviteValidTo(new Date(response.data.invited_valid_to));
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, []);
  console.log(recruiters)

  console.log(vaScore)



  const handleAiSettingsComplete = () => {
    setAiComplete(true);
    setActiveSection("both");
    setIncludeAiQuestions(true)
  };

  useEffect(() => {
    if (!includeAiQuestions) {
      setSettingsVisible(true)
    }

  }, [includeAiQuestions])

  const selectedManagerOption = useMemo(
    () => formattedAllUsers.find((o) => o.value === manager) ?? null,
    [formattedAllUsers, manager]
  );


  const selectedRecruiterOption = useMemo(
    () => recruiters.find((o) => o.value === recruiter) ?? null,
    [recruiters, recruiter]
  );

  const handleHackerrankSettingsComplete = () => {

    axiosInstance
      .patch(`${server_API}/v2/job/update`, {
        companyid: cid,
        uuid: jid,
        hackerrank_enabled: true,
        hackerrank_test_id: selectedOption.value,
        hackerrank_test_name: selectedOption.label,
        invited_valid_from: convertToUTCString(inviteValidFrom),
        invited_valid_to: convertToUTCString(inviteValidTo),
      })
      .then((response) => {

      })
      .catch((err) => {
        console.log(err);
      });
    setHackerrankComplete(true);
    setActiveSection("both");
  };

	  const handleCoderbyteSettingsComplete = () => {
	    axiosInstance
	      .patch(`${server_API}/v2/job/update`, {
        companyid: cid,
        uuid: jid,
        coderbyte_enabled: true,
        coderbyte_test_id: selectedCoderbyteOption.value,
        coderbyte_test_name: selectedCoderbyteOption.label,
        coderbyte_test_url: selectedCoderbyteOption.url || "",
        invited_valid_from: convertToUTCString(coderbyteInviteValidFrom),
        invited_valid_to: convertToUTCString(coderbyteInviteValidTo),
      })
      .then((response) => {

      })
      .catch((err) => {
        console.log(err);
      });
    setCoderbyteComplete(true);
    setActiveSection("both");
  };

  const handleRemoveHackerrank = () => {
    axiosInstance
      .patch(`${server_API}/v2/job/update`, {
        companyid: cid,
        uuid: jid,
        hackerrank_enabled: false,
        hackerrank_test_id: "",
        hackerrank_test_name: "",
        invited_valid_from: "",
        invited_valid_to: "",
      })
      .then((response) => {
        setHackerrankComplete(false);
        setSelectedOption(null);
        setInviteValidFrom(null);
        setInviteValidTo(null);
        setActiveSection("both");
        toast.success("HackerRank assessment removed successfully!", {
          position: "top-right",
          className: "bg-green-500 text-white",
        });
      })
      .catch((err) => {
        console.log(err);
        toast.error("Failed to remove HackerRank assessment");
      });
  };

  const handleRemoveCoderbyte = () => {
    axiosInstance
      .patch(`${server_API}/v2/job/update`, {
        companyid: cid,
        uuid: jid,
        coderbyte_enabled: false,
        coderbyte_test_id: "",
        coderbyte_test_name: "",
        coderbyte_test_url: "",
        invited_valid_from: "",
        invited_valid_to: "",
      })
      .then((response) => {
        setCoderbyteComplete(false);
        setSelectedCoderbyteOption(null);
        setCoderbyteInviteValidFrom(null);
        setCoderbyteInviteValidTo(null);
        setActiveSection("both");
        toast.success("Coderbyte assessment removed successfully!", {
          position: "top-right",
          className: "bg-green-500 text-white",
        });
      })
      .catch((err) => {
        console.log(err);
        toast.error("Failed to remove Coderbyte assessment");
      });
  };

  useEffect(() => {

    axiosInstance
      .get(`${server_API}/v2/job/hackerrank/test/${cid}`)
      .then((response) => {
        const data = response.data;


        const formattedOptions = data.map((test) => ({
          value: test.id,
          label: test.name,
        }));

        setTestOptions(formattedOptions);

      })
      .catch((err) => {
        console.log(err);
      });

  }, []);

  useEffect(() => {
    if (cid) {
      setCoderbyteError("");
      axiosInstance
        .get(`${server_API}/v2/job/coderbyte/test/${cid}`)
        .then((response) => {
          const data = response.data || [];
          if (data.length === 0) {
            setCoderbyteError("No assessments found in Coderbyte account.");
          }
          const formattedOptions = data.map((test) => ({
            value: test.id,
            label: test.name,
            url: test.public_url || test.url,
          }));
          setCoderbyteOptions(formattedOptions);
        })
        .catch((err) => {
          console.log(err);
          const errMsg = err.response?.data?.message || err.response?.data?.error || "Failed to fetch tests from Coderbyte.";
          setCoderbyteError(errMsg);
        });
    }
  }, [cid]);

  console.log(testOptions)
  console.log(selectedOption)

  useEffect(() => {
    if (qid) {
      axiosInstance
        .get(`${server_API}/v2/question/get/${qid}/${cid}`)
        .then((response) => {
          // console.log(response);
          var que = response.data.questions;
          let q = que.map((obj) => {
            obj["question"] = obj["Question"];
            delete obj["Question"];
            obj["answer"] = obj["Answer"];
            delete obj["Answer"];
            return obj;
          });
          setQuestions(q);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [qid]);

  const JobCreate = () => {

    axiosInstance
      .get(`${server_API}/v2/job/get/${jid}/${cid}`)
      .then((response) => {
        axiosInstance.post(`/v2/job/create`, {
          "companyid": response.data.companyid,
          "jobstatus": "Draft",
          "profilename": response.data.profilename,
          "positionnumber": response.data.positionnumber,
          "workstyle": response.data.workstyle,
          "postdate": response.data.postdate,
          "closedate": response.data.closingDate,
          "saveas": "template",
          "department": response.data.department,
          "jdsummary": response.data.jdsummary,
          "experience": response.data.experience,
          "jobtype": response.data.jobtype,
          "applicationlastdate": response.data.applicationlastdate,
          "voiceanalysisscore": response.data.voiceanalysisscore,
          "location:": response.data["location:"],
          "salaryfrom": response.data.salaryfrom,
          "manual_trigger": response.data.manual_trigger,
          "resume_threshold": response.data.resume_threshold,
          "salaryto": response.data.salaryto,
          "jobdescription": response.data.jobdescription,
          "requirnmenet": response.data.requirements,
          "skills": response.data.skills,
          "resumecompatibility": response.data.resumecompatibility,
          "assignrecruiter": response.data.assignrecruiter,
          "assignhiringmanager": response.data.assignhiringmanager,
          "firstreminder": response.data.firstreminder,
          "finalreminder": response.data.finalreminder,
          "selectedapplication": response.data.selectedapplication,
          "interviewed": response.data.interviewed,
          "aiscore": response.data.aiscore,
          "totalapplication": 0,
          "preferredlanguage": response.data.preferredlanguage,
          "questionid": response.data.questionid,
          "technicalweight": response.data.technicalweight,
          "normaltext": response.data.normaltext,
          "displaysalary": response.data.displaysalary,
          "created_by": response.data.created_by,
          "hackerrank_enabled": response.data.hackerrank_enabled || false,
          "hackerrank_test_id": response.data.hackerrank_test_id || "",
          "hackerrank_test_name": response.data.hackerrank_test_name || "",
          "coderbyte_enabled": response.data.coderbyte_enabled || false,
          "coderbyte_test_id": response.data.coderbyte_test_id || "",
          "coderbyte_test_name": response.data.coderbyte_test_name || "",
          "coderbyte_test_url": response.data.coderbyte_test_url || "",
          "invited_valid_from": response.data.invited_valid_from || "",
          "invited_valid_to": response.data.invited_valid_to || "",
          "position_type": response.data.position_type,
          "new_position_comments": response.data.new_position_comments,
          "min_dob": response.data.min_dob,
          "min_education": response.data.min_education,
          "aicalling": response.data.aicalling,
          ...((isEverestIms || isSocketAI) && {
            required_skills: response.data.required_skills,
          }),
          ...(isEverestIms && {
            ctc_buffer_percent: response.data.ctc_buffer_percent,
          }),
          ...(fromAcfl && {
            acfl_detail: {
              "active_employees_same_grade": response.data.active_employees_same_grade,
              "min_salary_same_grade": response.data.min_salary_same_grade,
              "max_salary_same_grade": response.data.max_salary_same_grade,
              "replacement_employee_name": response.data.replacement_employee_name,
              "replacement_employee_code": response.data.replacement_employee_code,
              "replacement_employee_location": response.data.replacement_employee_location,
              "replacement_employee_designation": response.data.replacement_employee_designation,
            }
          })
        })
          .then((response) => {
            toast("Job successfully saved as template!", {
              position: "top-right",
              className: "bg-green-500 text-white",
            });
          })
          .catch((error) => {
            console.log(error);
          })
      })
      .catch((err) => {
        console.log(err);
      });

  }

  const deleteJob = (id) => {

    axiosInstance.delete(`/v2/job/delete/${id}/${cid}`)
      .then((response) => {
        console.log(response)
        navigate("/jobs")
      })
      .catch((error) => {
        console.log(error)
      })
  }


  // UK localization applies only when the company's primary country (company_countries[0]) is GB
  const isGB = companyCountryCode === "GB";
  const isSG = companyCountryCode === "SG";

  const ukCities = [
    { label: "London", value: "London" },
    { label: "Birmingham", value: "Birmingham" },
    { label: "Manchester", value: "Manchester" },
    { label: "Leeds", value: "Leeds" },
    { label: "Glasgow", value: "Glasgow" },
    { label: "Liverpool", value: "Liverpool" },
    { label: "Newcastle", value: "Newcastle" },
    { label: "Sheffield", value: "Sheffield" },
    { label: "Bristol", value: "Bristol" },
    { label: "Nottingham", value: "Nottingham" },
    { label: "Leicester", value: "Leicester" },
    { label: "Edinburgh", value: "Edinburgh" },
    { label: "Cardiff", value: "Cardiff" },
    { label: "Belfast", value: "Belfast" },
    { label: "Coventry", value: "Coventry" },
    { label: "Bradford", value: "Bradford" },
    { label: "Stoke-on-Trent", value: "Stoke-on-Trent" },
    { label: "Wolverhampton", value: "Wolverhampton" },
    { label: "Plymouth", value: "Plymouth" },
    { label: "Southampton", value: "Southampton" },
    { label: "Reading", value: "Reading" },
    { label: "Derby", value: "Derby" },
    { label: "Portsmouth", value: "Portsmouth" },
    { label: "Brighton", value: "Brighton" },
    { label: "Hull", value: "Hull" },
    { label: "Preston", value: "Preston" },
    { label: "Aberdeen", value: "Aberdeen" },
    { label: "Swansea", value: "Swansea" },
    { label: "Milton Keynes", value: "Milton Keynes" },
    { label: "Norwich", value: "Norwich" },
    { label: "Luton", value: "Luton" },
    { label: "Sunderland", value: "Sunderland" },
    { label: "Oxford", value: "Oxford" },
    { label: "Cambridge", value: "Cambridge" },
    { label: "York", value: "York" },
    { label: "Dundee", value: "Dundee" },
    { label: "Exeter", value: "Exeter" },
    { label: "Gloucester", value: "Gloucester" },
    { label: "Bath", value: "Bath" },
    { label: "Ipswich", value: "Ipswich" },
  ];

  const indianCities = [
    { label: "Delhi", value: "Delhi" },
    { label: "Mumbai", value: "Mumbai" },
    { label: "Kolkata", value: "Kolkata" },
    { label: "Chennai", value: "Chennai" },
    { label: "Jaipur", value: "Jaipur" },
    { label: "Pune", value: "Pune" },
    { label: "Ahmedabad", value: "Ahmedabad" },
    { label: "Bangalore", value: "Bangalore" },
    { label: "Hyderabad", value: "Hyderabad" },
    { label: "Surat", value: "Surat" },
    { label: "Agra", value: "Agra" },
    { label: "Kanpur", value: "Kanpur" },
    { label: "Lucknow", value: "Lucknow" },
    { label: "Nagpur", value: "Nagpur" },
    { label: "Indore", value: "Indore" },
    { label: "Bhopal", value: "Bhopal" },
    { label: "Chandigarh", value: "Chandigarh" },
    { label: "Patna", value: "Patna" },
    { label: "Dehradun", value: "Dehradun" },
    { label: "Coimbatore", value: "Coimbatore" },
    { label: "Madurai", value: "Madurai" },
    { label: "Vijayawada", value: "Vijayawada" },
    { label: "Mangalore", value: "Mangalore" },
    { label: "Mysore", value: "Mysore" },
    { label: "Trivandrum", value: "Trivandrum" },
    { label: "Tirupati", value: "Tirupati" },
    { label: "Nellore", value: "Nellore" },
    { label: "Guntur", value: "Guntur" },
    { label: "Warangal", value: "Warangal" },
    { label: "Kurnool", value: "Kurnool" },
    { label: "Rajahmundry", value: "Rajahmundry" },
    { label: "Bhubaneswar", value: "Bhubaneswar" },
    { label: "Guwahati", value: "Guwahati" },
    { label: "Ranchi", value: "Ranchi" },
    { label: "Jamshedpur", value: "Jamshedpur" },
    { label: "Cuttack", value: "Cuttack" },
    { label: "Durgapur", value: "Durgapur" },
    { label: "Asansol", value: "Asansol" },
    { label: "Siliguri", value: "Siliguri" },
    { label: "Dhanbad", value: "Dhanbad" },
    { label: "Rourkela", value: "Rourkela" },
    { label: "Haldia", value: "Haldia" },
    { label: "Agartala", value: "Agartala" },
    { label: "Shillong", value: "Shillong" },
    { label: "Imphal", value: "Imphal" },
    { label: "Kohima", value: "Kohima" },
    { label: "Aizawl", value: "Aizawl" },
    { label: "Gangtok", value: "Gangtok" },
    { label: "Itanagar", value: "Itanagar" },
    { label: "Dimapur", value: "Dimapur" },
    { label: "Silchar", value: "Silchar" },
    { label: "Dibrugarh", value: "Dibrugarh" },
    { label: "Tripura", value: "Tripura" },
    { label: "Jorhat", value: "Jorhat" },
    { label: "Gurugram", value: "Gurugram" },
  ];

  const singaporeCities = [
    { label: "Singapore", value: "Singapore" },
    { label: "Jurong East", value: "Jurong East" },
    { label: "Jurong West", value: "Jurong West" },
    { label: "Woodlands", value: "Woodlands" },
    { label: "Tampines", value: "Tampines" },
    { label: "Bedok", value: "Bedok" },
    { label: "Ang Mo Kio", value: "Ang Mo Kio" },
    { label: "Yishun", value: "Yishun" },
    { label: "Hougang", value: "Hougang" },
    { label: "Sengkang", value: "Sengkang" },
    { label: "Punggol", value: "Punggol" },
    { label: "Pasir Ris", value: "Pasir Ris" },
    { label: "Toa Payoh", value: "Toa Payoh" },
    { label: "Bishan", value: "Bishan" },
    { label: "Clementi", value: "Clementi" },
    { label: "Bukit Batok", value: "Bukit Batok" },
    { label: "Bukit Panjang", value: "Bukit Panjang" },
    { label: "Choa Chu Kang", value: "Choa Chu Kang" },
    { label: "Queenstown", value: "Queenstown" },
    { label: "Novena", value: "Novena" },
    { label: "Orchard", value: "Orchard" },
    { label: "Marina Bay", value: "Marina Bay" },
    { label: "Raffles Place", value: "Raffles Place" },
    { label: "Serangoon", value: "Serangoon" },
    { label: "Kallang", value: "Kallang" },
    { label: "Geylang", value: "Geylang" },
    { label: "Changi", value: "Changi" },
    { label: "HarbourFront", value: "HarbourFront" },
    { label: "Bugis", value: "Bugis" },
    { label: "Sentosa", value: "Sentosa" },
  ];

  const cityOptions = {
    IN: indianCities,
    GB: ukCities,
    SG: singaporeCities,
  };

  const majorCities = cityOptions[companyCountryCode] || indianCities;

  const languageOptionsConfig = {
    IN: [
      { label: "English", value: "EN" },
      { label: "Bi-lingual (Hindi)", value: "HI" },
    ],
  };

  const getLanguageOptions = (countryCode) => {
    return languageOptionsConfig[countryCode] || [
      { label: "English", value: "EN" },
    ];
  };

  const salaryValidationMessages = {
    IN: "Verify the annual salary for the job and update, e.g. Update 400000 for 4 LPA.",
    SG: "Enter the full annual salary amount in SGD. Example: 50000.",
    GB: "Enter the full annual salary amount. Example: 50000.",
  };

  const getSalaryValidationMessage = (countryCode) => {
    return salaryValidationMessages[countryCode] || "Enter the full annual salary amount. Example: 50000.";
  };

  const options = [
    { value: 'Campus campaign', label: 'Campus campaign' },
    { value: 'Company website', label: 'Company website' },
    { value: 'Employees referral', label: 'Employees referral' },
    { value: 'Naukri', label: 'Naukri' },
    { value: 'Indeed', label: 'Indeed' },
    { value: 'LinkedIn', label: 'LinkedIn' },
    { value: 'Recruitment agency', label: 'Recruitment agency' },
    { value: 'Others', label: 'Others' }
  ];

  const checkValue = (e) => {
    setSingleSingle(e.target.value);
    if (
      singleSkill.length > 0 &&
      singleSkill.charAt(singleSkill.length - 1) == ","
    ) {
      const new_str = singleSkill.slice(0, -1);
      aiSkills.push(new_str);
      setSingleSingle("");
    }
  };

  useEffect(() => {
    if (admin) {
      setWs("On-Site");
    } else if (editor) {
      setWs("Hybrid");
    } else if (viewer) {
      setWs("Remote");
    }
  }, [admin, editor, viewer]);

  const navigate = useNavigate();

  const loc = useLocation();

  useEffect(() => {
    if (location.length > 0) {
      const lv = location.map((l) => {
        return l.value;
      });
      setLocationValues(lv);
    }
  }, [location]);

  useEffect(() => {
    if (loc.state != null && loc.state.job != null && saveas != "template") {
      const job = loc.state.job;
      setDescription(job.jobdescription || "");
      setTitle(job.profilename || "");
      setResCom(job.resumecompatibility || "");
      setIntScore(job.aiscore || 0);
      setVAScore(job.voiceanalysisscore || 0);
    }
  }, []);

  const datePickerId = isGB
    ? formatISODate(new Date(), GB_TIMEZONE)
    : new Date().toISOString().split("T")[0];

  const onlyContainsNumbers = (str) => /^[0-9,.]*$/.test(str);

  const salaryFromFunc = (value) => {
    const sanitizedValue = value.replace(/,/g, "");

    if (onlyContainsNumbers(sanitizedValue)) {
      const numericValue = Number(sanitizedValue);

      // Minimum salary check (non-internship)
      if (jtype !== "Internship" && numericValue < ((isGB || isSG) ? 10000 : 100000)) {
        setMinimumSalaryError(true);
        // toast.error("Verify the annual salary for the job and update, e.g. Update 400000 for 4 LPA",{position:"top-center"})
      } else {
        setMinimumSalaryError(false);
      }

      // Format the number with commas
      const formattedValue = numericValue.toLocaleString();
      setSalaryFrom(formattedValue);
    } else {
      setSalaryFrom("");
      setMinimumSalaryError(false);
    }
  };


  const salaryToFunc = (value) => {
    // const { value } = event.target;
    // Remove any existing commas from the input
    if (onlyContainsNumbers(value)) {
      const sanitizedValue = value.replace(/,/g, "");

      // Format the number with commas
      const formattedValue = Number(sanitizedValue).toLocaleString();

      setSalaryTo(formattedValue);
    } else {
      setSalaryTo("");
    }
  };

  const jobTypeOptions = [
    { value: 'Full-time', label: 'Full-Time' },
    { value: 'Part-time', label: 'Part-Time' },
    { value: 'Internship', label: 'Internship' },
  ];

  const departmentOptions = departments.map((d) => ({
    value: d,
    label: d,
  }));
  const gradeOptions = activeGrades.map((item) => ({
    value: item.grade,
    label: `${item.title} (${item.grade})`,
  }));
  const selectedGradeLabel =
    gradeOptions.find((option) => option.value === grade)?.label || grade;
  console.log(total)

  const genJd = () => {
    const cl = `Join ${companyName} and play a pivotal role in shaping an impactful business growth. Apply today to embark on a rewarding career journey with us.`;
    const urls = [
      `${server_API}/v2/job/rs/generate`,
      `${server_API}/v2/job/bd/generate`,
      `${server_API}/v2/job/rr/generate`,
    ];
    setLoader(true);
    // console.log(prompt);
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      promt: `${prompt}`,
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };


    // let req = urls.map((u)=>{
    //   console.log(u);
    //   fetch(u, requestOptions)
    // })

    const data = Promise.all([
      fetch(urls[0], requestOptions),
      fetch(urls[1], requestOptions),
      fetch(urls[2], requestOptions),
    ]).then((responses) =>
      Promise.all(
        responses.map((r) => {
          setLoader(false);
          setOpenPrompt(false);
          return r.json();
        })
      )
    );

    const extractData = async () => {
      const d = await data;

      const des = `
    <html>
    ${aboutUs}
    <br></br>
    ${d[1].success}
    <br></br>
    ${d[2].success}
    <br></br>
    ${d[0].success}
    <br></br>
    <p>${cl}</p>
    </html>
    `;
      setDescription(des);
    };

    extractData();



    // Promise.all(req)
    //   .then(responses => {
    //     console.log(responses)
    //   return responses;
    // })
    // .then(responses => Promise.all(responses.map(r => {
    //   console.log(r.json())
    // })))

    // fetch(`${server_API}/v2/job/jd/generate`, requestOptions)
    //   .then((response) => response.json())
    //   .then((result) => {
    //     console.log(result);
    //     setLoader(false);
    //     const des = result.success;
    //     // des.toLowerCase().replace(title.toLowerCase(),' ')
    //     setDescription(des);
    //     setOpenPrompt(false);
    //   })
    //   .catch((error) => console.log("error", error));
  };

  // const rid= localStorage.getItem("uuid");
  const rid = useSelector(selectUuid);


  const convertToUTCString = (dateInput) => {
    let year, month, day;

    if (isGB) {
      if (!dateInput) return dateInput;
      // Resolve the calendar date in GB (Europe/London) time, then force UTC midnight on it
      [year, month, day] = formatISODate(dateInput, GB_TIMEZONE).split("-");
    } else {
      const localDate = new Date(dateInput);

      // Get the local year, month, and date (NOT UTC)
      year = localDate.getFullYear();
      month = String(localDate.getMonth() + 1).padStart(2, '0'); // month is 0-based
      day = String(localDate.getDate()).padStart(2, '0');
    }

    // Force UTC midnight on that date
    return `${year}-${month}-${day}T00:00:00+0000`;
  };

  console.log(convertToUTCString(inviteValidFrom))



  const handleFromChange = (e) => {
    setInviteValidFrom(e.target.value);
  };

  const handleToChange = (e) => {
    setInviteValidTo(e.target.value);
  };
  const getTodayDate = () => {
    return isGB
      ? formatISODate(new Date(), GB_TIMEZONE)
      : new Date().toISOString().split("T")[0];
  };

  console.log(inviteValidFrom)
  const [submitLoader, setSubmitLoader] = useState(false); // define this at top in your component

  const handleSubmit = async () => {
    setSubmitLoader(true); // show loader

    if (!skipTech) {
      await questionUpdate(); // wait for this to complete
    } else {
      patchSubmit(false);
    }

    handleAiSettingsComplete();


    setSubmitLoader(false); // hide loader
  };


  console.log(qid)

  useEffect(() => {
    window.scrollTo(0, 0);
    axiosInstance.get(`/v2/company/get/${cid}`)
      .then((response) => {
        setCompanyName(response.data.name);
        setIsEverestIms(response.data.is_everestIMS || false);
        setIsSocketAI(response.data.is_socketAI || false);
        // Capture Country Code from Company Response
        if (response.data.company_countries && response.data.company_countries.length > 0) {
          setCompanyCountryCode(response.data.company_countries[0]);
        }
        setHackerRankEnabled(response.data.hackerrankenabled)
        setCoderbyteEnabled(response.data.coderbyteenabled || false)
        setFromAcfl(response.data.from_acfl || false);
        setHasApproverFlow(response.data.hasApproverFlow || false);
        setHasAiCalling(false);
        if (response.data.departments) {
          setDepartments(response.data.departments);
        } else {
          setDepartments([]);
        }
        const usableGrades = (response.data.grades || []).filter(
          (item) => item?.use_in_job_workflows && item?.title && item?.grade,
        );
        setActiveGrades(usableGrades);
        const customLocs = response.data.custom_locations || [];
        const formattedLocs = customLocs.map(v => ({ label: v, value: v }));
        setCustomLocations(formattedLocs);
        setManualTriggerEnabled(response.data?.manual_trigger)
        setAboutUs(response.data.generatedaboutus);
        // console.log(response)
        axiosInstance
          .get(`${server_API}/v2/user/company/${cid}`)
          .then((response) => {
            setAllUsers(response.data.message.Users);
          })
          .catch((err) => {
            setAllUsers([]);
          });
      })
      .catch((error) => {
        setDepartments([]);
        console.log(error);
      });

    axiosInstance.get(`/v2/user/getuser/${rid}`)
      .then((res) => {
        setPrivilege(res.data.privilege)
      })
      .catch((err) => {
        console.log(err)
      })
  }, []);


  useEffect(() => {
    if (allUsers.length > 0) {
      if (flag == false) {
        const users = allUsers.filter((item) => {
          if (item.status == "accepted") {
            Object.defineProperty(
              item,
              "value",
              Object.getOwnPropertyDescriptor(item, "uuid")
            );
            Object.defineProperty(
              item,
              "label",
              Object.getOwnPropertyDescriptor(item, "name")
            );
            return item;
          }
        });
        setFormattedAllUsers(users);
        setFlag(true);
      }
      const editorOrViewers = allUsers.filter((f) => {
        if (f.status == "accepted" && f.privilege != "Hiring Manager") {
          Object.defineProperty(
            f,
            "value",
            Object.getOwnPropertyDescriptor(f, "uuid")
          );
          Object.defineProperty(
            f,
            "label",
            Object.getOwnPropertyDescriptor(f, "name")
          );
          return f;
        }
      });
      setRecruiters(editorOrViewers);

      // Filter job approvers
      const approvers = allUsers.filter((user) => {
        if (user.status === "accepted" && user.is_approver === true && user.job_approver === true) {
          return true;
        }
        return false;
      }).map((user) => ({
        value: user.uuid,
        label: user.name
      }));
      setJobApprovers(approvers);
    }
  }, [allUsers]);

  const convertHtmlToPlainText = (html) => {
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.body.textContent || "";
  };

  useEffect(() => {
    if (questions.length > 0 && questions[0].question.length > 0) {
      setTotal(
        parseInt(resCom || 0) +
        parseInt(intScore || 0) +
        parseInt(vaScore || 0) +
        parseInt(techWeight || 0)
      );
    } else {
      setTotal(
        parseInt(resCom || 0) +
        parseInt(intScore || 0) +
        parseInt(vaScore || 0)
      );
    }
  }, [vaScore, intScore, techWeight, questions, resCom]);


  const genAiQUestions = (questionCount = numQuestions) => {
    const text = convertHtmlToPlainText(description);

    axiosInstance
      .post(`${server_API}/v2/job/jdsummary`, {
        jobdescription: text,
      })
      .then((response) => {
        const title = response?.data?.success;
        setJdSum(title);
      })
      .catch((err) => {
        console.log("JD summary error:", err);
      });

    axiosInstance
      .post(`${server_API}/v2/job/qna/generate`, {
        jobtitle: title,
        numquestions: questionCount,
        jobdescription: text,
        experience: `${experience} - ${maxExp} years`
      })
      .then((response) => {
        const ques = response.data.success || [];
        const formatted = ques.map((q) => ({
          question: q.question.replace("Q: ", "").trim(),
          answer: q.answer.replace("A: ", "").trim(),
        }));
        setQuestions(formatted);
        setGenAiLoader(false);
      })
      .catch((err) => {
        console.log("QnA generate error:", err);
        setGenAiLoader(false);
      });
  };


  const patchSubmit = (change) => {
    const text = convertHtmlToPlainText(description);
    if (privilege != "Admin" && manager === "") {
      setManager(rid)
    }
    let updatedRecruiter = recruiter;

    if (recruiter === "") {
      updatedRecruiter = rid;
      setRecuiter(rid);
    }
    if (jid) {
      axiosInstance
        .patch(`${server_API}/v2/job/update`, {
          uuid: jid,
          companyid: cid,
          jobstatus: "Draft",
          questionid: qid,
          profilename: title,
          positionnumber: parseInt(noOfPositions),
          workstyle: ws,
          department: department,
          saveas: "draft",
          aiinterviewenabled: includeAiQuestions,
          experience: `${experience || 0} - ${maxExp || 0} years`,
          jobtype: jtype,
          applicationlastdate: lda,
          voiceanalysisscore: parseInt(vaScore),
          location: locationValues.toString(),
          salaryfrom: salaryFrom,
          salaryto: salaryTo,
          grade: grade,
          jobdescription: description,
          requirnmenet: requirements,
          skills: skills,
          resumecompatibility: resCom.toString(),
          normaltext: text,
          assignrecruiter: updatedRecruiter,
          assignhiringmanager: manager,
          additional_recruiters: additionalRecruitersAndHrms.additionalRecruiters?.map((item) => item?.value),
          additional_hrms: additionalRecruitersAndHrms.additionalHrms?.map((item) => item?.value),
          firstreminder: parseInt(rem1),
          finalreminder: parseInt(rem2),
          selectedapplication: 0,
          interviewed: 0,
          displaysalary: isSalaryVisible,
          jdsummary: jdSum,
          aiscore: parseInt(intScore),
          preferredlanguage: language,
          totalapplication: 0,
          technicalweight: parseInt(techWeight),
          manual_trigger: manualtrigger,
          resume_threshold: !manualtrigger ? trigger : 0,
          position_type: positionType,
          new_position_comments: newPositionComments,
          min_dob: minDob,
          min_education: minEducation,
          aicalling: aiCalling,
          ...((isEverestIms || isSocketAI) && {
            required_skills: requiredSkillsList,
          }),
          ...(isEverestIms && {
            ctc_buffer_percent: ctcBuffer,
          }),
          ...(fromAcfl && {
            acfl_detail: {
              active_employees_same_grade: activeEmployeesSameGrade,
              min_salary_same_grade: minSalarySameGrade,
              max_salary_same_grade: maxSalarySameGrade,
              replacement_employee_name: replacementEmployeeName,
              replacement_employee_code: replacementEmployeeCode,
              replacement_employee_location: replacementEmployeeLocation,
              replacement_employee_designation: replacementEmployeeDesignation,
            }
          })
        })
        .then((response) => {
          if (change) {
            setTab(tab + 1);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      axiosInstance
        .post(`${server_API}/v2/job/create`, {
          companyid: cid,
          jobstatus: "Draft",
          profilename: title,
          positionnumber: parseInt(noOfPositions),
          workstyle: ws,
          department: department,
          saveas: "draft",
          aiinterviewenabled: includeAiQuestions,
          experience: `${experience || 0} - ${maxExp || 0} years`,
          jobtype: jtype,
          applicationlastdate: lda,
          voiceanalysisscore: parseInt(vaScore),
          "location:": locationValues.toString(),
          salaryfrom: salaryFrom,
          salaryto: salaryTo,
          grade: grade,
          jobdescription: description,
          requirnmenet: requirements,
          displaysalary: isSalaryVisible,
          skills: skills,
          resumecompatibility: "0",
          normaltext: text,
          assignrecruiter: updatedRecruiter,
          aicalling: aiCalling,
          assignhiringmanager: manager,
          manual_trigger: manualtrigger,
          resume_threshold: !manualtrigger ? trigger : 0,
          // firstreminder: parseInt(rem1),
          // finalreminder: parseInt(rem2),
          selectedapplication: 0,
          interviewed: 0,
          // aiscore: parseInt(intScore),
          totalapplication: 0,
          // questionid: "",
          // technicalweight: parseInt(techWeight),
          created_by: rid,
          additional_recruiters: additionalRecruitersAndHrms.additionalRecruiters.map((item) => item.value),
          additional_hrms: additionalRecruitersAndHrms.additionalHrms.map((item) => item.value),
          position_type: positionType,
          new_position_comments: newPositionComments,
          min_dob: minDob,
          min_education: minEducation,
          ...((isEverestIms || isSocketAI) && {
            required_skills: requiredSkillsList,
          }),
          ...(isEverestIms && {
            ctc_buffer_percent: ctcBuffer,
          }),
          ...(fromAcfl && {
            acfl_detail: {
              active_employees_same_grade: activeEmployeesSameGrade,
              min_salary_same_grade: minSalarySameGrade,
              max_salary_same_grade: maxSalarySameGrade,
              replacement_employee_name: replacementEmployeeName,
              replacement_employee_code: replacementEmployeeCode,
              replacement_employee_location: replacementEmployeeLocation,
              replacement_employee_designation: replacementEmployeeDesignation,
            }
          })
        })
        .then((response) => {
          setJid(response.data.sucess);
          localStorage.setItem("jid", response.data.sucess);
          // console.log(response);
          if (change) {
            setTab(tab + 1);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const dropdownRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    }

    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open]);

  const questionUpdate = () => {
    setQuestionSaveLoader(true)
    if (qid) {
      axiosInstance
        .patch(`${server_API}/v2/question/update`, {
          uuid: qid,
          companyid: cid,
          questions: questions,
        })
        .then((response) => {
          // console.log(response);
          // setTab(3);
          setSettingsVisible(true)
          setQuestionSaveLoader(false)
        })
        .catch((err) => {
          setQuestionSaveLoader(false)
          console.log(err);
        });
    } else {
      axiosInstance
        .post(`${server_API}/v2/question/create`, {
          companyid: cid,
          questions: questions,
        })
        .then((response) => {
          setQid(response.data.success)
          axiosInstance
            .patch(`${server_API}/v2/job/update`, {
              companyid: cid,
              uuid: jid,
              questionid: response.data.success,
              manual_trigger: manualtrigger,
              resume_threshold: !manualtrigger ? trigger : 0,
            })
            .then((response) => {
              setSettingsVisible(true)
              setQuestionSaveLoader(false)
            })
            .catch((err) => {
              console.log(err);
            });
        });
    }
  };

  console.log(includeAiQuestions)
  console.log(questions)
  console.log(qid)

  const jobSubmit = (temp) => {
    const text = convertHtmlToPlainText(description);
    const status = (temp == "template" ? "Draft" : "Open")

    axiosInstance
      .patch(`${server_API}/v2/job/update`, {
        companyid: cid,
        uuid: jid,
        saveas: temp,
        jdsummary: jdSum,
        jobstatus: status,
        createdat: utcDate,
        manual_trigger: manualtrigger,
        resume_threshold: !manualtrigger ? trigger : 0,
      })
      .then((res) => {
        if (temp == "template") {
          toast("Job successfully saved as template!", {
            position: "top-right",
            className: "bg-green-500 text-white",
          });
        } else {
          setPostedSucessfully(true)
          localStorage.removeItem("jid");
        }
      });

  };

  const sendJobForApproval = () => {
    if (!selectedApprover) {
      toast.error("Please select an approver", {
        position: "top-right",
      });
      return;
    }

    setApprovalLoading(true);

    axiosInstance
      .post("/v2/job/approval", {
        jobid: jid,
        companyid: cid,
        userid: selectedApprover.value,
      })
      .then(() => {
        axiosInstance
          .patch(`${server_API}/v2/job/update`, {
            companyid: cid,
            uuid: jid,
            jobstatus: "Pending",
            updatedat: utcDate,
            saveas: "Pending",
          })
          .then(() => {
            toast.success("Job sent for approval successfully!", {
              position: "top-right",
              className: "bg-green-500 text-white",
            });
            setShowApprovalModal(false);
            setSelectedApprover(null);
            setApprovalLoading(false);
            // Optionally navigate to jobs page or refresh
            setTimeout(() => {
              navigate("/jobs");
            }, 1500);
          })
          .catch((err) => {
            console.log(err);
            toast.error("Failed to send job for approval", {
              position: "top-right",
            });
            setApprovalLoading(false);
          });
      })
      .catch((err) => {
        console.log(err);
        toast.error("Failed to send job for approval", {
          position: "top-right",
        });
        setApprovalLoading(false);
      });
  };

  const deleteByIndex = (index) => {
    if (questions.length === 1) {
      setShowConfirm(true);
    } else {

      const updatedQuestions = [...questions];
      updatedQuestions.splice(index, 1);
      setQuestions(updatedQuestions);
    }
  };


  const spliceArray = (e, i) => {
    e.preventDefault();
    let myarray = [...aiSkills];
    myarray.splice(i, 1);
    console.log(myarray);
    setAiSkills(myarray);
  };

  console.log(location);

  const handleChange = (index, e) => {
    const { name, value } = e.target;

    const newData = questions.map((f, i) => {
      if (index === i) {
        return {
          ...f,
          [name]: value,
          // If the user is typing in the `question` field, set `answer` as "Not Answered" (if still empty)
          ...(name === "question" && !f.answer ? { answer: "Not Answered" } : {})
        };
      }
      return f;
    });

    setQuestions(newData);
  };


  const savedEnabled = () => {
    if (includeAiQuestions == null) {
      return false;
    }
    else {
      if (includeAiQuestions == true) {
        if (languageVisible == true) {
          return true
        }
        else {
          return false;
        }
      }
      else {
        return true;
      }
    }
  }


  useEffect(() => {
    if (salaryTo && salaryFrom) {
      const salaryToNum = parseInt(salaryTo.replaceAll(",", ""));
      const salaryFromNum = parseInt(salaryFrom.replaceAll(",", ""));
      console.log(salaryToNum, " ", salaryFromNum);
      if (salaryToNum <= salaryFromNum) {
        setSalaryFormated(true);
      } else {
        setSalaryFormated(false);
      }
    }
  }, [salaryTo, salaryFrom]);

  const jdSumGeneration = () => {
    const text = convertHtmlToPlainText(description);
    axiosInstance
      .post(`${server_API}/v2/job/jdsummary`, {
        jobdescription: text,
      })
      .then((response) => {
        setJdSum(response.data.success);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    if (experience && maxExp) {
      const experienceNum = parseInt(experience.replaceAll(",", ""));
      const maxExpNum = parseInt(maxExp.replaceAll(",", ""));

      if (experienceNum > maxExpNum) {
        setExperienceFormated(true);
      } else {
        setExperienceFormated(false);
      }
    }
  }, [experience, maxExp]);

  const getSelectedUserIds = () => {
    const ids = new Set();
    if (recruiter) ids.add(recruiter);
    if (manager) ids.add(manager);
    additionalRecruitersAndHrms.additionalRecruiters?.forEach(u => u && ids.add(u.value));
    additionalRecruitersAndHrms.additionalHrms?.forEach(u => u && ids.add(u.value));
    return ids;
  };

  const selectedUserIds = getSelectedUserIds();

  const getFilteredOptions = (baseOptions, currentValues = []) => {
    const currentIds = new Set();
    if (Array.isArray(currentValues)) {
      currentValues.forEach(v => v && currentIds.add(v.value));
    } else if (currentValues) {
      currentIds.add(currentValues);
    }

    return baseOptions.filter(option => !selectedUserIds.has(option.value) || currentIds.has(option.value));
  };

  return (
    <div className="bg-[#f0f4fc] min-h-screen relative">
      <ToastContainer />
      {
        postedSucessfully &&
        (isNewUi ?
          <OpenJob navigate={navigate} jid={jid} cid={cid} setOpenPopup={setPostedSucessfully} />
          : <div className="fixed bg-white border shadow-xl md:w-3/4 p-6 z-40 rounded-xl left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 overflow-y-auto max-h-[90vh]">
            <div className="flex flex-col space-y-6">

              {/* Close Button */}
              <div className="flex justify-end">
                <button
                  onClick={() => navigate('/jobs')}
                  className="font-bold text-gray-500 hover:text-black text-xl"
                >
                  ✕
                </button>
              </div>

              <div className="flex flex-col md:flex-row gap-6">

                {/* Left Section: Info + Share */}
                <div className="md:w-[40%] flex flex-col items-center space-y-4 text-center">
                  <img src={success} className="h-28" alt="Success" />
                  <p className="text-[#0DCD94] text-xl font-semibold">Congratulations!</p>
                  <p className="text-xl font-semibold">New job published</p>

                  {/* Job Link */}
                  <div className="flex items-center space-x-2 justify-center w-full overflow-x-auto">
                    <p className="font-semibold text-black">Job link:</p>
                    <a
                      className="text-blue-500 underline truncate max-w-[200px]"
                      href={`https://northstarz.ai/ats/#/careers/${jid}/${cid}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      https://northstarz.ai/ats/#/careers/{jid}/{cid}
                    </a>
                    <button
                      onClick={() =>
                        navigator.clipboard.writeText(
                          `https://northstarz.ai/ats/#/careers/${jid}/${cid}`
                        )
                      }
                      className="w-[2rem]"
                    >
                      <img src={share_copy} className="h-8 w-full" alt="Copy" />
                    </button>
                  </div>

                  {/* Social Icons */}
                  <div className="flex flex-wrap justify-center gap-4 mt-2">
                    <EmailShareButton subject="Posted Job Link" body={`https://northstarz.ai/ats/#/careers/${jid}/${cid}`}>
                      <img src={share_mail} className="h-10" alt="Email" />
                    </EmailShareButton>
                    <TwitterShareButton url={`https://northstarz.ai/ats/#/careers/${jid}/${cid}`}>
                      <img src={share_x} className="h-10" alt="Twitter" />
                    </TwitterShareButton>
                    <FacebookShareButton url={`https://northstarz.ai/ats/#/careers/${jid}/${cid}`}>
                      <img src={share_fb} className="h-10" alt="Facebook" />
                    </FacebookShareButton>
                    <WhatsappShareButton url={`https://northstarz.ai/ats/#/careers/${jid}/${cid}`}>
                      <img src={share_whatsapp} className="h-10 p-2 bg-[#F1F4FB] rounded-lg" alt="WhatsApp" />
                    </WhatsappShareButton>
                    <LinkedinShareButton title="Posted Job Link" url={`https://northstarz.ai/ats/#/careers/${jid}/${cid}`}>
                      <img src={share_linkedin} className="h-10" alt="LinkedIn" />
                    </LinkedinShareButton>
                  </div>
                </div>

                {/* === Divider === */}
                <div className="hidden md:flex w-[1px] relative bg-gray-300 mx-2">
                  <div className="absolute top-0 h-10 w-full bg-gradient-to-b from-white to-transparent"></div>
                  <div className="absolute bottom-0 h-10 w-full bg-gradient-to-t from-white to-transparent"></div>
                </div>

                {/* === Right Section: Video Cards === */}
                <div className="w-full md:w-[60%] flex  gap-6">

                  {/* Video 1 */}
                  <div className="relative rounded-xl overflow-hidden shadow-md">
                    {/* Overlay that allows clicks to pass through */}
                    <div className="absolute inset-0 bg-black bg-opacity-50 pointer-events-none"></div>

                    {/* Title moved above the iframe */}
                    <p className="absolute top-2 left-2 z-10 text-white font-semibold text-sm md:text-base bg-black bg-opacity-60 px-2 py-1 rounded">
                      Publish Job on Job Boards
                    </p>

                    {/* Actual YouTube iframe */}
                    <iframe
                      className="w-full h-full rounded-lg relative z-0"
                      src="https://www.youtube.com/embed/Yi0NRrN_Fw0"
                      title="Publish Job"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    ></iframe>
                  </div>


                  {/* Video 2 */}
                  <div className="relative rounded-xl overflow-hidden shadow-md">
                    {/* Overlay that allows clicks to pass through */}
                    <div className="absolute inset-0 bg-black bg-opacity-50 pointer-events-none"></div>

                    {/* Title moved above the iframe */}
                    <p className="absolute top-2 left-2 z-10 text-white font-semibold text-sm md:text-base bg-black bg-opacity-60 px-2 py-1 rounded">
                      Invite Candidates from Job Boards
                    </p>

                    {/* Actual YouTube iframe */}
                    <iframe
                      className="w-full h-full rounded-lg relative z-0"
                      src="https://www.youtube.com/embed/_XBM_rkwfsM"
                      title="Publish Job"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    ></iframe>
                  </div>


                </div>
              </div>
            </div>
          </div>)
      }
      {openPopup && (
        <div className="bg-white w-1/2  shadow-2xl border rounded-xl p-4 z-20 fixed left-1/2 top-1/2 -translate-y-1/2  -translate-x-1/2">
          <button
            className="text-right "
            onClick={() => {
              setOpenPopup(false);
            }}
          >
            X
          </button>
          <div className="text-center">
            <p className="">
              Assign a weight score to each of the below parameter as required
              for the job role. The Skills weightage will help you to identify
              your top candidates based on the job requirement.
            </p>
            <p>
              Ensure the sum total of all weighted scores will be 100. E.g. For
              a Customer Success role, the weights could look like:
            </p>
            <p>Resume compatibility: 25</p>
            <p>Video interview score: 60</p>
            <p>Voice analysis score: 15</p>
            <p>Total score: 100</p>
          </div>
        </div>
      )}
      {openPrompt && (
        <div className="bg-white w-1/2  shadow-2xl border rounded-xl p-4 z-20 fixed left-1/2 top-1/2 -translate-y-1/2  -translate-x-1/2">
          <button
            className="text-right "
            onClick={() => {
              setOpenPrompt(false);
            }}
          >
            X
          </button>
          <div>
            <p className="font-semibold text-xl my-2">
              Job description using AI
            </p>
            <p className="font-semibold my-1 mt-5">Prompt</p>
            <textarea
              rows="4"
              value={prompt}
              onChange={(e) => {
                setPrompt(e.target.value);
              }}
              className="p-2 rounded-xl outline-none border w-full"
              placeholder="Share in a few sentences what your are hiring for"
            ></textarea>
            <div className="text-right">
              <button
                onClick={() => {
                  genJd();
                }}
                className="bg-[#148EFF] px-5 py-2 rounded-lg text-white mt-3"
              >
                {loader ? (
                  <TailSpin color="white" height="30" width="30"></TailSpin>
                ) : (
                  "Generate"
                )}
              </button>
            </div>
          </div>
        </div>
      )}
      <div
        className={
          openPopup || openPrompt || postedSucessfully
            ? "blur p-4 md:px-10 pt-5"
            : "p-4 md:px-10 pt-5"
        }
      >

        <div className="flex justify-start items-center space-x-4">
          <div className="tooltip" onClick={() => {
            if (saveas == "template" && tab == 0) {
              deleteJob(jid)
            } else {
              navigate(-1)
            }
          }}>
            <IoMdArrowBack className="text-2xl my-3"></IoMdArrowBack>
            <p className="tooltiptext">Back</p>
          </div>
          <p className="text-2xl font-semibold">New Jobs</p>
        </div>
        <div className="mt-6 bg-white rounded-xl ">
          <div className="flex items-center justify-start bg-[#F1F4FB] rounded-t-xl">
            <button
              onClick={() => {
                setTab(0);
              }}
              className={
                tab == 0
                  ? "px-5 py-3 bg-white rounded-t-xl font-semibold"
                  : "rounded-t-xl px-5 py-3"
              }
            >
              Job details
            </button>
            <button
              onClick={() => {
                setTab(1);
              }}
              disabled={
                !(
                  title &&
                  jtype &&
                  noOfPositions &&
                  experience &&
                  location.length > 0 &&
                  department
                )
              }
              className={
                tab == 1
                  ? "px-5 py-3 bg-white rounded-t-xl font-semibold"
                  : "rounded-t-xl px-5 py-3"
              }
            >
              Job description
            </button>
            <button
              onClick={() => {
                setTab(2);
              }}
              disabled={!description}
              className={
                tab == 2
                  ? "px-5 py-3 bg-white rounded-t-xl font-semibold"
                  : "rounded-t-xl px-5 py-3"
              }
            >
              Job Modules
            </button>
            <button
              onClick={() => {
                setTab(3);
              }}
              disabled={!description}
              className={
                tab == 3
                  ? "px-5 py-3 bg-white rounded-t-xl font-semibold"
                  : "rounded-t-xl px-5 py-3"
              }
            >
              Summary
            </button>


          </div>
          {tab == 0 && (
            <div>
              <div className="p-5  rounded-xl ">
                <div className="flex flex-col space-y-4">
                  <div className="flex w-full space-x-3">
                    <div className="w-1/2">
                      <p className="font-semibold">
                        Job title <span className="text-red-500">*</span>
                      </p>
                      <input
                        onChange={(e) => {
                          setTitle(e.target.value);
                        }}
                        value={title}
                        autocapitalize="word"
                        style={{ textTransform: "capitalize" }}
                        className=" outline-none border px-2 pt-2 pb-[0.35rem] w-full rounded-lg mt-2"
                      ></input>
                    </div>
                    <div className="w-1/2">
                      <p className="font-semibold">
                        Job type <span className="text-red-500">*</span>
                      </p>
                      <Select
                        options={jobTypeOptions}
                        value={jobTypeOptions.find(option => option.value === jtype)}
                        onChange={(selectedOption) => {
                          setType(selectedOption ? selectedOption.value : '');
                        }}
                        className="border  rounded-lg mt-2"
                        classNamePrefix="react-select"
                        isClearable
                        placeholder="Select job type"
                        styles={{
                          control: (provided, state) => ({
                            ...provided,
                            border: "none",
                            boxShadow: "none",
                          }),
                        }}
                      />
                    </div>
                  </div>
                  <div className="flex w-full space-x-3">
                    <div className="w-1/2">
                      <p className="font-semibold">
                        No of openings <span className="text-red-500">*</span>
                      </p>
                      <input
                        value={noOfPositions}
                        onChange={(e) => {
                          setNoOfPositions(e.target.value);
                        }}
                        className="w-full outline-none border px-2 pt-2 pb-[0.35rem] rounded-lg mt-2"
                        type="text"
                      ></input>
                    </div>
                    <div className="w-1/2">
                      <p className="font-semibold">
                        Department <span className="text-red-500">*</span>
                      </p>
                      <Select
                        options={departmentOptions}
                        value={
                          departmentOptions.find((option) => option.value === department)
                        }
                        onChange={(selectedOption) => {
                          setDepartment(selectedOption ? selectedOption.value : '');
                        }}
                        className="border  rounded-lg mt-2 "
                        classNamePrefix="react-select"
                        isClearable
                        placeholder="Select department"
                        styles={{
                          control: (provided, state) => ({
                            ...provided,
                            border: "none",
                            boxShadow: "none",
                          }),
                        }}
                      />
                    </div>
                  </div>

                  <div className="flex w-full items-start space-x-3">
                    {/* <div className="w-1/2">
                      <p className="font-semibold">Last date to apply </p>
                      <input
                        value={lda}
                        // id="datePickerId"
                        min={datePickerId}
                        onChange={(e) => {
                          setLda(e.target.value);
                        }}
                        className={
                          datePickerId > lda
                            ? "w-full outline-red-500 border-r-[30px] border px-2 py-2  rounded-lg mt-2"
                            : "w-full outline-none border-r-[30px] border px-2 py-2 rounded-lg mt-2"
                        }
                        type="date"
                        // min={`${date.getFullYear()}-${date.getMonth()+1}-${date.getDate()}`}
                      ></input>
                      {datePickerId > lda && (
                        <p className="text-red-500">
                          The last date to apply cannot be later than the
                          current date
                        </p>
                      )}
                    </div> */}
                    <div className="flex w-1/2 items-start gap-4">
                      {/* Annual Salary Range */}
                      <div className="lg:w-1/2 w-2/3 pr-2">
                        <p className="font-semibold mb-2">
                          Annual Salary Range <span className="text-red-500">*</span>
                        </p>
                        <div className="flex">
                          <input
                            value={salaryFrom}
                            onChange={(e) => {
                              salaryFromFunc(e.target.value);
                            }}
                            placeholder="From e.g. 300,000"
                            className={` outline-none border w-full ${minimumSalaryError ? "border-red-500" : ""
                              } px-2 py-2 rounded-l-lg`}
                            type="text"
                          />
                          <input
                            value={salaryTo}
                            onChange={(e) => {
                              salaryToFunc(e.target.value);
                            }}
                            placeholder="To e.g. 500,000"
                            className={` outline-none w-full border ${salaryformated ? "border-red-500" : ""
                              } px-2 py-2 rounded-r-lg`}
                            type="text"
                          />
                        </div>
                        {minimumSalaryError && (
                          <p className="text-red-500 mt-1">
                            {getSalaryValidationMessage(companyCountryCode)}
                          </p>
                        )}
                        {salaryformated && (
                          <p className="text-red-500 mt-1">
                            The salary "to" cannot be less than salary "from"
                          </p>
                        )}
                      </div>

                      {/* Display salary to candidates */}
                      <div className="w-1/3 lg:w-1/2">
                        <span className="font-semibold mb-2 flex flex-col"><p>Show salary at job advert</p></span>
                        <div className="flex space-x-4 items-center">
                          <label className="flex items-center space-x-1 cursor-pointer">
                            <input
                              type="radio"
                              name="displaySalary"
                              value="yes"
                              checked={isSalaryVisible === true}
                              onChange={() => setIsSalaryVisible(true)}
                              className="cursor-pointer"
                            />
                            <span>Yes</span>
                          </label>
                          <label className="flex items-center space-x-1 cursor-pointer">
                            <input
                              type="radio"
                              name="displaySalary"
                              value="no"
                              checked={isSalaryVisible === false}
                              onChange={() => setIsSalaryVisible(false)}
                              className="cursor-pointer"
                            />
                            <span>No</span>
                          </label>
                        </div>
                      </div>
                    </div>

                    <div className="w-1/2 flex flex-col">
                      <p className="font-semibold mb-2">
                        Required experience in years <span className="text-red-500">*</span>
                      </p>
                      <div className="flex items-center">
                        {/* Experience From */}
                        <div className="w-1/2 flex items-center space-x-2">
                          <input
                            value={experience}
                            onChange={(e) => {
                              setExperience(e.target.value);
                            }}
                            placeholder="Minimum e.g. 2"
                            className="w-full outline-none border px-2 py-2 rounded-l-lg"
                            type="number"
                            onWheel={(e) => e.target.blur()}
                          />
                        </div>

                        {/* Experience To */}
                        <div className="w-1/2 flex items-center space-x-2">
                          <input
                            value={maxExp}
                            onChange={(e) => {
                              setMaxExp(e.target.value);
                            }}
                            placeholder="Maximum e.g. 5"
                            className={`w-full outline-none border ${experienceFormated ? "border-red-500" : ""
                              } px-2 py-2 rounded-r-lg`}
                            type="number"
                            onWheel={(e) => e.target.blur()}
                          />
                        </div>
                      </div>
                      {experienceFormated && (
                        <p className="text-red-500 mt-1">
                          Maximum Experience cannot be less than Minimum Experience
                        </p>
                      )}
                    </div>

                  </div>
                  <div className="flex w-full space-x-3 items-start">
                    <div className="w-1/2">
                      <p className="font-semibold">Work style </p>
                      <div className="flex my-3 items-center w-full space-x-3">
                        <div className="flex items-center space-x-2">
                          <input
                            type="checkbox"
                            onChange={(e) => {
                              if (e.target.checked == true) {
                                setAdmin(true);
                                setEditor(false);
                                setViewer(false);
                              }
                            }}
                            checked={admin}
                          ></input>
                          <p>On-site</p>
                        </div>
                        <div className="flex items-center space-x-2">
                          <input
                            onChange={(e) => {
                              if (e.target.checked == true) {
                                setAdmin(false);
                                setEditor(true);
                                setViewer(false);
                              }
                            }}
                            checked={editor}
                            type="checkbox"
                          ></input>
                          <p>Hybrid</p>
                        </div>
                        <div className="flex items-center space-x-2">
                          <input
                            onChange={(e) => {
                              if (e.target.checked == true) {
                                setAdmin(false);
                                setEditor(false);
                                setViewer(true);
                              }
                            }}
                            checked={viewer}
                            type="checkbox"
                          ></input>
                          <p>Remote</p>
                        </div>
                      </div>
                    </div>
                    <div className="w-1/2">
                      <p className="font-semibold">
                        Location <span className="text-red-500">*</span>{" "}
                      </p>
                      <CreatableSelect
                        value={location}
                        onChange={(selectedOption) => {
                          setLocation(selectedOption);
                          if (selectedOption && Array.isArray(selectedOption)) {
                            const newItems = selectedOption.filter(
                              (opt) =>
                                !majorCities.some((m) => m.value === opt.value) &&
                                !customLocations.some((c) => c.value === opt.value)
                            );
                            if (newItems.length > 0) {
                              const newCustomLocs = [...customLocations, ...newItems];
                              setCustomLocations(newCustomLocs);
                              const stringValues = newCustomLocs.map(opt => opt.value);
                              axiosInstance.patch('/v2/company/update', {
                                uuid: cid,
                                custom_locations: stringValues
                              }).catch(err => console.log('Error saving location', err));
                            }
                          }
                        }}
                        className="w-full border  rounded-lg mt-2"
                        options={[...majorCities, ...(customLocations || [])]}
                        isClearable
                        isMulti
                        isSearchable
                        placeholder="Select or create a city..."
                        styles={{
                          control: (provided, state) => ({
                            ...provided,
                            border: "none",
                            boxShadow: "none",
                          }),
                        }}
                      />

                      {/* <input
                        value={location}
                        onChange={(e) => {
                          setLocation(e.target.value);
                        }}
                        className="w-full outline-none border px-2 py-2 rounded-lg mt-2"
                        type="text"
                      ></input> */}
                    </div>
                  </div>

                  <div className="flex w-full space-x-3">
                    <div className="w-1/2">
                      <p className="font-semibold">Select hiring manager</p>
                      <Select
                        options={getFilteredOptions(formattedAllUsers, manager)}
                        value={selectedManagerOption}
                        onChange={(option) => {
                          if (option != null) {
                            setManager(option.value);
                          }
                        }}
                        isClearable="true"
                        className="border  rounded-lg mt-2"
                        styles={{
                          control: (provided, state) => ({
                            ...provided,
                            border: "none",
                            boxShadow: "none",
                          }),
                        }}

                      />
                      {/* <input
                        className="w-full outline-none border px-2 py-2 rounded-lg mt-2"
                        type="text"
                        value={manager}
                        onChange={(e)=>{setManager(e.target.value)}}
                      ></input> */}
                    </div>
                    <div className="w-1/2">
                      <p className="font-semibold">Additional hiring manager</p>
                      <Select
                        options={getFilteredOptions(formattedAllUsers, additionalRecruitersAndHrms.additionalHrms)}
                        value={additionalRecruitersAndHrms.additionalHrms}
                        isMulti
                        onChange={(option) => {
                          if (option != null) {
                            setAdditionalRecruitersAndHrms({
                              ...additionalRecruitersAndHrms,
                              additionalHrms: [...option]
                            });

                            console.log({ option });
                          }
                        }}
                        isClearable="true"
                        className="border  rounded-lg mt-2"
                        styles={{
                          control: (provided, state) => ({
                            ...provided,
                            border: "none",
                            boxShadow: "none",
                          }),
                        }}

                      />
                      {/* <input
                        className="w-full outline-none border px-2 py-2 rounded-lg mt-2"
                        type="text"
                        value={manager}
                        onChange={(e)=>{setManager(e.target.value)}}
                      ></input> */}
                    </div>
                  </div>

                  <div className="flex w-full space-x-3">
                    <div className="w-1/2">
                      <p className="font-semibold">Select recruiter</p>
                      <Select
                        options={getFilteredOptions(recruiters, recruiter)}
                        value={selectedRecruiterOption}
                        onChange={(option) => {
                          // console.log(option);
                          // console.log(option);
                          if (option != null) {
                            setRecuiter(option.value);
                          }
                        }}
                        isClearable="true"
                        className="border  rounded-lg mt-2"
                        styles={{
                          control: (provided, state) => ({
                            ...provided,
                            border: "none",
                            boxShadow: "none",
                          }),
                        }}
                      />
                      {/* <input
                        className="w-full outline-none border px-2 py-2 rounded-lg mt-2"
                        type="text"
                        value={manager}
                        onChange={(e)=>{setManager(e.target.value)}}
                      ></input> */}
                    </div>
                    <div className="w-1/2">
                      <p className="font-semibold">Additional recruiters</p>
                      <Select
                        options={getFilteredOptions(recruiters, additionalRecruitersAndHrms.additionalRecruiters)}
                        value={additionalRecruitersAndHrms.additionalRecruiters}
                        isMulti
                        onChange={(option) => {
                          if (option != null) {
                            setAdditionalRecruitersAndHrms({
                              ...additionalRecruitersAndHrms,
                              additionalRecruiters: [...option]
                            });
                          }
                        }}
                        isClearable="true"
                        className="border  rounded-lg mt-2"
                        styles={{
                          control: (provided, state) => ({
                            ...provided,
                            border: "none",
                            boxShadow: "none",
                          }),
                        }}
                      />
                      {/* <input
                        className="w-full outline-none border px-2 py-2 rounded-lg mt-2"
                        type="text"
                        value={manager}
                        onChange={(e)=>{setManager(e.target.value)}}
                      ></input> */}
                    </div>
                  </div>

                  {gradeOptions.length > 0 && (
                    <div className="flex w-full space-x-3">
                      <div className="w-1/2">
                        <p className="font-semibold">
                          Grade <span className="text-red-500">*</span>
                        </p>
                        <Select
                          options={gradeOptions}
                          value={gradeOptions.find((option) => option.value === grade) || null}
                          onChange={(selectedOption) => {
                            setGrade(selectedOption ? selectedOption.value : "");
                          }}
                          className="border rounded-lg mt-2"
                          classNamePrefix="react-select"
                          isClearable
                          placeholder="Select grade"
                          styles={{
                            control: (provided, state) => ({
                              ...provided,
                              border: "none",
                              boxShadow: "none",
                            }),
                          }}
                        />
                      </div>
                    </div>
                  )}

                  {(isEverestIms || isSocketAI) && (
                    <div className="flex flex-col w-full mt-6 transition-all">
                      <div className="bg-[#E9EBFA] h-[0.1rem] w-full mb-6"></div>
                      <div className="flex items-center space-x-3 mb-5">
                        <p className="font-semibold text-gray-800 text-lg tracking-tight">Evaluation Parameters</p>
                      </div>

                      {isEverestIms && (
                        <div className="flex w-full space-x-4 mb-6">
                          <div className="w-1/2">
                            <p className="font-semibold text-gray-700 text-sm mb-1.5">Maximum CTC Buffer Threshold <span className="text-red-500">*</span></p>
                            <div className="relative">
                              <input
                                className="w-full outline-none border border-gray-200 px-3 py-2.5 rounded-lg focus:border-[#148EFF] transition-all font-medium text-gray-700 placeholder-gray-400"
                                type="text"
                                value={ctcBuffer}
                                placeholder="e.g. 7"
                                onChange={(e) => {
                                  if (onlyContainsNumbers(e.target.value)) {
                                    setCtcBuffer(e.target.value);
                                  }
                                }}
                              />
                              <div className="absolute inset-y-0 right-0 pr-4 flex items-center pointer-events-none">
                                <span className="text-gray-400 font-semibold">%</span>
                              </div>
                            </div>
                            <p className="text-xs text-gray-500 mt-1.5 ml-1">Percent extension permitted over Job Max CTC.</p>
                          </div>
                        </div>
                      )}

                      <div className="w-full">
                        <div className="flex justify-between items-center mb-4">
                          <p className="font-semibold text-gray-800 text-sm">Required Technical Competencies <span className="text-red-500">*</span></p>
                          <div className="flex items-center space-x-1.5">
                            <span className={`text-[11px] font-bold px-2 py-1 rounded-md ${requiredSkillsList.length >= 4 ? 'bg-orange-100 text-orange-700' : 'bg-gray-100 text-gray-600'}`}>
                              {requiredSkillsList.length}/4
                            </span>
                          </div>
                        </div>

                        <div className="space-y-3">
                          {requiredSkillsList.map((item, index) => (
                            <div key={index} className="flex space-x-3 items-center group">
                              <div className="w-[50%]">
                                <input
                                  className="w-full text-sm outline-none border border-gray-200 px-3 py-2 rounded-lg focus:border-[#148EFF] transition-colors placeholder-gray-400 font-medium"
                                  placeholder="Skill Name (e.g. React.js)"
                                  value={item.skill}
                                  onChange={(e) => {
                                    const newSkills = [...requiredSkillsList];
                                    newSkills[index].skill = e.target.value;
                                    setRequiredSkillsList(newSkills);
                                  }}
                                />
                              </div>
                              <div className="w-[40%] flex items-center border border-gray-200 rounded-lg overflow-hidden focus-within:border-[#148EFF] transition-colors">
                                <button
                                  className="px-3 py-2 bg-gray-50 text-gray-600 hover:bg-gray-100 font-bold transition-all border-r border-gray-200 outline-none"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    const newSkills = [...requiredSkillsList];
                                    const minExp = parseInt(newSkills[index].minExp || "0");
                                    if (minExp > 0) {
                                      newSkills[index].minExp = (minExp - 1).toString();
                                      setRequiredSkillsList(newSkills);
                                    }
                                  }}
                                >
                                  -
                                </button>
                                <input
                                  className="w-full text-sm outline-none px-3 py-2 text-center text-gray-700 font-medium m-0"
                                  placeholder="Yrs"
                                  type="text"
                                  value={item.minExp}
                                  onChange={(e) => {
                                    if (onlyContainsNumbers(e.target.value)) {
                                      const newSkills = [...requiredSkillsList];
                                      newSkills[index].minExp = e.target.value;
                                      setRequiredSkillsList(newSkills);
                                    }
                                  }}
                                />
                                <button
                                  className="px-3 py-2 bg-gray-50 text-gray-600 hover:bg-gray-100 font-bold transition-all border-l border-gray-200 outline-none"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    const newSkills = [...requiredSkillsList];
                                    const minExp = parseInt(newSkills[index].minExp || "0");
                                    newSkills[index].minExp = (minExp + 1).toString();
                                    setRequiredSkillsList(newSkills);
                                  }}
                                >
                                  +
                                </button>
                              </div>
                              <div className="w-[10%] flex justify-center">
                                {requiredSkillsList.length > 1 ? (
                                  <button
                                    className="p-1.5 text-gray-400 hover:text-red-500 hover:bg-red-50 rounded-lg transition-all opacity-0 group-hover:opacity-100 focus:opacity-100"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      const newSkills = [...requiredSkillsList];
                                      newSkills.splice(index, 1);
                                      setRequiredSkillsList(newSkills);
                                    }}
                                    title="Remove Skill"
                                  >
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                      <path fillRule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clipRule="evenodd" />
                                    </svg>
                                  </button>
                                ) : (
                                  <div className="w-8"></div>
                                )}
                              </div>
                            </div>
                          ))}
                        </div>

                        {requiredSkillsList.length < 4 && (
                          <button
                            className="mt-4 flex items-center justify-center space-x-2 w-full py-2 rounded border border-gray-200 text-[#148EFF] font-semibold text-sm hover:bg-[#148EFF]/5 transition-all text-left"
                            onClick={(e) => {
                              e.preventDefault();
                              setRequiredSkillsList([...requiredSkillsList, { skill: "", minExp: "" }]);
                            }}
                          >
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                              <path fillRule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clipRule="evenodd" />
                            </svg>
                            <span>Add Mandatory Skill</span>
                          </button>
                        )}
                        {requiredSkillsList.length >= 4 && (
                          <div className="mt-4 flex items-center justify-center space-x-2 w-full py-2 rounded bg-gray-50 border border-gray-100 text-gray-400 font-medium text-sm cursor-not-allowed text-left">
                            <span>Maximum 4 skills limit reached</span>
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                  {fromAcfl && (
                    <div className="flex w-full space-x-3 mt-4">
                      <div className="w-1/2">
                        <p className="font-semibold">Min. Salary in the Same Grade/Rank <span className="text-red-500">*</span></p>
                        <input
                          className="w-full outline-none border px-2 py-2 rounded-lg mt-2 font-medium"
                          type="text"
                          value={minSalarySameGrade}
                          placeholder="Enter amount"
                          onChange={(e) => {
                            if (onlyContainsNumbers(e.target.value)) {
                              setMinSalarySameGrade(e.target.value);
                            }
                          }}
                        ></input>
                      </div>
                      <div className="w-1/2">
                        <p className="font-semibold">Max. Salary in the Same Grade/Rank<span className="text-red-500">*</span></p>
                        <input
                          className="w-full outline-none border px-2 py-2 rounded-lg mt-2 font-medium"
                          type="text"
                          value={maxSalarySameGrade}
                          placeholder="Enter amount"
                          onChange={(e) => {
                            if (onlyContainsNumbers(e.target.value)) {
                              setMaxSalarySameGrade(e.target.value);
                            }
                          }}
                        ></input>
                      </div>
                    </div>
                  )}

                  <div className="flex w-full space-x-3 mt-4">
                    {fromAcfl && (
                      <div className="w-1/2">
                        <p className="font-semibold">Total Active Employees in Same Grade/Rank <span className="text-red-500">*</span></p>
                        <input
                          className="w-full outline-none border px-2 py-2 rounded-lg mt-2 font-medium"
                          type="text"
                          value={activeEmployeesSameGrade}
                          placeholder="Enter count"
                          onChange={(e) => {
                            if (onlyContainsNumbers(e.target.value)) {
                              setActiveEmployeesSameGrade(e.target.value);
                            }
                          }}
                        ></input>
                      </div>
                    )}
                    {fromAcfl && (
                      <div className="w-1/2">
                        <p className="font-semibold">Type of Position <span className="text-red-500">*</span></p>
                        <div className="flex items-center space-x-6 mt-3">
                          <label className="flex items-center space-x-2 cursor-pointer">
                            <input
                              type="radio"
                              name="positionType"
                              value="New"
                              checked={positionType === "New"}
                              onChange={(e) => setPositionType(e.target.value)}
                              className="w-4 h-4 text-[#148EFF] focus:ring-[#148EFF]"
                            />
                            <span className="font-medium">New</span>
                          </label>
                          <label className="flex items-center space-x-2 cursor-pointer">
                            <input
                              type="radio"
                              name="positionType"
                              value="Replacement"
                              checked={positionType === "Replacement"}
                              onChange={(e) => setPositionType(e.target.value)}
                              className="w-4 h-4 text-[#148EFF] focus:ring-[#148EFF]"
                            />
                            <span className="font-medium">Replacement</span>
                          </label>
                        </div>
                      </div>
                    )}
                  </div>

                  {fromAcfl && positionType === "New" && (
                    <div className="w-full mt-4">
                      <p className="font-semibold">Comments <span className="text-red-500">*</span></p>
                      <textarea
                        className="w-full outline-none border px-2 py-2 rounded-lg mt-2 font-medium"
                        rows="3"
                        value={newPositionComments}
                        placeholder="Enter comments here..."
                        onChange={(e) => setNewPositionComments(e.target.value)}
                      ></textarea>
                    </div>
                  )}

                  {fromAcfl && positionType === "Replacement" && (
                    <>
                      <div className="flex w-full space-x-3 mt-4">
                        <div className="w-1/2">
                          <p className="font-semibold">Name of Existing Employee <span className="text-red-500">*</span></p>
                          <input
                            className="w-full outline-none border px-2 py-2 rounded-lg mt-2 font-medium"
                            type="text"
                            value={replacementEmployeeName}
                            onChange={(e) => setReplacementEmployeeName(e.target.value)}
                          ></input>
                        </div>
                        <div className="w-1/2">
                          <p className="font-semibold">Employee Code <span className="text-red-500">*</span></p>
                          <input
                            className="w-full outline-none border px-2 py-2 rounded-lg mt-2 font-medium"
                            type="text"
                            value={replacementEmployeeCode}
                            onChange={(e) => setReplacementEmployeeCode(e.target.value)}
                          ></input>
                        </div>
                      </div>
                      <div className="flex w-full space-x-3 mt-4">
                        <div className="w-1/2">
                          <p className="font-semibold">Current Location of the employee <span className="text-red-500">*</span></p>
                          <input
                            className="w-full outline-none border px-2 py-2 rounded-lg mt-2 font-medium"
                            type="text"
                            value={replacementEmployeeLocation}
                            onChange={(e) => setReplacementEmployeeLocation(e.target.value)}
                          ></input>
                        </div>
                        <div className="w-1/2">
                          <p className="font-semibold">Designation <span className="text-red-500">*</span></p>
                          <input
                            className="w-full outline-none border px-2 py-2 rounded-lg mt-2 font-medium"
                            type="text"
                            value={replacementEmployeeDesignation}
                            onChange={(e) => setReplacementEmployeeDesignation(e.target.value)}
                          ></input>
                        </div>
                      </div>
                    </>
                  )}

                  {fromAcfl && <>
                    <div className="bg-[#E9EBFA] h-[0.1rem] w-full mt-6"></div>
                    <div className="mt-4">
                      <p className="font-semibold text-lg">Additional settings</p>
                      <div className="flex w-full space-x-3 mt-4">
                        <div className="w-1/2">
                          <p className="font-semibold">Maximum Age <span className="text-red-500">*</span></p>
                          <Select
                            value={minDob ? { value: minDob, label: minDob } : null}
                            onChange={(opt) => setMinDob(opt ? opt.value : "")}
                            options={Array.from({ length: 42 }, (_, i) => ({
                              value: (i + 19).toString(),
                              label: (i + 19).toString(),
                            }))}
                            className="mt-2"
                            placeholder="Select Maximum Age"
                            isClearable
                          />
                        </div>
                        <div className="w-1/2">
                          <p className="font-semibold">Minimum Education <span className="text-red-500">*</span></p>
                          <Select
                            value={minEducation ? { value: minEducation, label: minEducation } : null}
                            onChange={(opt) => setMinEducation(opt.value)}
                            options={[
                              { value: "10th", label: "10th" },
                              { value: "12th", label: "12th" },
                              { value: "Diploma", label: "Diploma" },
                              { value: "Bachelors/Graduations", label: "Bachelors/Graduations" },
                              { value: "Masters/Post Graduation", label: "Masters/Post Graduation" },
                              { value: "PhD", label: "PhD" }
                            ]}
                            className="mt-2"
                            placeholder="Select Qualification"
                          />
                        </div>
                      </div>
                    </div>
                  </>}

                  {
                    hasAiCalling && (
                      <>
                        <div className="bg-[#E9EBFA] h-[0.1rem] w-full mt-6"></div>
                        <div className="mt-4">
                          <p className="font-semibold text-lg">Additional settings</p>
                          <div className="flex w-full space-x-3 mt-4">
                            <div className="w-1/2">
                              <p className="font-semibold">AI Calling <span className="text-red-500">*</span></p>
                              <div className="flex items-center space-x-4 mt-2">
                                <label className="flex items-center space-x-2">
                                  <input type="radio" name="aiCalling" value="yes" checked={aiCalling} onChange={(e) => setAiCalling(true)} />
                                  <span>Yes</span>
                                </label>
                                <label className="flex items-center space-x-2">
                                  <input type="radio" name="aiCalling" value="no" checked={!aiCalling} onChange={(e) => setAiCalling(false)} />
                                  <span>No</span>
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    )
                  }


                </div>
              </div>
              <div className="bg-[#E9EBFA] h-[0.1rem] w-full"></div>
              <div className="flex  px-4 py-5 items-center justify-end w-full">
                <button
                  disabled={
                    !(
                      title &&
                      jtype &&
                      noOfPositions &&
                      experience &&
                      location.length > 0 &&
                      salaryTo &&
                      salaryFrom &&
                      !salaryformated &&
                      !experienceFormated && !minimumSalaryError
                      && Number(experience) <= Number(maxExp) &&
                      (!gradeOptions.length || grade) &&
                      (!fromAcfl || (
                        minSalarySameGrade &&
                        maxSalarySameGrade &&
                        minDob &&
                        minEducation && positionType &&
                        activeEmployeesSameGrade &&
                        (positionType === "New" ? newPositionComments : (
                          replacementEmployeeName &&
                          replacementEmployeeCode &&
                          replacementEmployeeLocation &&
                          replacementEmployeeDesignation
                        ))
                      )) &&
                      (!isEverestIms || (
                        ctcBuffer &&
                        requiredSkillsList.length > 0 &&
                        requiredSkillsList.every(skill => skill.skill.trim() !== "" && skill.minExp.trim() !== "")
                      )) &&
                      (!isSocketAI || (
                        requiredSkillsList.length > 0 &&
                        requiredSkillsList.every(skill => skill.skill.trim() !== "" && skill.minExp.trim() !== "")
                      ))
                    )
                  }
                  className={
                    title &&
                      jtype &&
                      noOfPositions &&
                      experience &&
                      location.length > 0 &&
                      salaryTo &&
                      salaryFrom &&
                      !salaryformated &&
                      !experienceFormated && !minimumSalaryError
                      && Number(experience) <= Number(maxExp) &&
                      (!gradeOptions.length || grade) &&
                      (!fromAcfl || (
                        minSalarySameGrade &&
                        maxSalarySameGrade &&
                        activeEmployeesSameGrade &&
                        minDob &&
                        minEducation &&
                        positionType &&
                        (positionType === "New" ? newPositionComments : (
                          replacementEmployeeName &&
                          replacementEmployeeCode &&
                          replacementEmployeeLocation &&
                          replacementEmployeeDesignation
                        ))
                      )) &&
                      (!isEverestIms || (
                        ctcBuffer &&
                        requiredSkillsList.length > 0 &&
                        requiredSkillsList.every(skill => skill.skill.trim() !== "" && skill.minExp.trim() !== "")
                      )) &&
                      (!isSocketAI || (
                        requiredSkillsList.length > 0 &&
                        requiredSkillsList.every(skill => skill.skill.trim() !== "" && skill.minExp.trim() !== "")
                      ))
                      ? "px-6 py-2 text-white bg-[#148EFF] rounded-xl"
                      : "px-6 py-2 text-white bg-gray-300 rounded-xl"
                  }
                  onClick={() => {
                    patchSubmit(true);
                    setSaveAs("draft")
                  }}
                >
                  Save & Next
                </button>
              </div>
            </div>
          )}
          {tab == 1 && (
            <div>
              <div className="p-5  rounded-xl ">
                <div className="flex flex-col space-y-4">
                  <p className="font-semibold text-2xl">{title}</p>
                  <div>
                    <div>
                      <div>
                        <div className="flex items-center space-x-6">
                          <p className="font-semibold">
                            Job description{" "}
                            <span className="text-red-500">*</span>
                          </p>
                          {
                            <button
                              onClick={() => {
                                setOpenPrompt(true);
                              }}
                              className="font-semibold   bg-gradient-to-r   from-[#F7284AA3] via-[#7366FFCC] to-[#0DCD94CC]   rounded-xl  p-[0.15rem]"
                            >
                              <div className="h-full p-2 rounded-lg w-full bg-white">
                                <p className="bg-gradient-to-r brightness-110 text-transparent bg-clip-text from-[#F7284AA3] via-[#7366FFCC] to-[#0DCD94CC]">
                                  Generate using AI
                                </p>
                              </div>
                            </button>
                          }
                        </div>
                      </div>
                    </div>
                    <ReactQuill
                      value={description}
                      onChange={(content) => {
                        console.log(content);
                        setDescription(content);
                      }}
                      rows="10"
                      theme="snow"
                      className=" w-full ql-container py-2 px-2 mt-2"
                      style={{ borderRadius: "20px" }}
                    ></ReactQuill>
                  </div>


                </div>
              </div>
              <div className="bg-[#E9EBFA] h-[0.1rem] w-full"></div>
              <div className="flex space-x-6  px-4 py-5 items-center justify-end w-full">
                <button
                  className="px-10 py-2 bg-white border border-[#148EFF] text-[#148EFF] rounded-xl"
                  onClick={() => {
                    setTab(tab - 1);
                  }}
                >
                  Back
                </button>
                <button
                  disabled={description.length < 50}
                  onClick={() => {
                    patchSubmit(true);
                  }}
                  className={
                    description.length > 50
                      ? "px-6 py-2 text-white bg-[#148EFF] rounded-xl"
                      : "px-6 py-2 text-white bg-gray-400 rounded-xl"
                  }
                >
                  Save & Next
                </button>
              </div>
            </div>
          )}
          {
            tab == 2 && (
              <div>
                <div className="p-5  rounded-xl ">
                  <div className="flex gap-2 py-4">
                    <p className="font-semibold text-2xl ">{title}</p>

                  </div>

                  <div className="items-center">
                    <div className="flex gap-6">
                      {(activeSection === "ai" || activeSection === "both") && (
                        <div className={`transition-opacity duration-500 ${isPublished ? 'opacity-50 pointer-events-none' : 'opacity-100 cursor-pointer'}`} onClick={() => {
                          setActiveSection("ai")

                        }}>
                          <div className={`items-center flex flex-col bg-[#f0f4fc] rounded-md p-4 border-[1px] shadow-md transition-all ${aiComplete ? 'border-[#148EFF] ring-1 ring-[#148EFF]' : 'border-[#d2d4da]'}`}>
                            <div className="flex flex-col gap-1 items-center">
                              <img src={AiLogo} className="w-[17rem]"></img>
                              <p className="font-semibold flex items-center gap-2">
                                AI Interview
                                {aiComplete && <span className="text-green-600 text-sm font-bold">✓</span>}
                              </p>
                            </div>
                            <div className="flex mt-2 items-start space-x-10">
                              <div className="flex space-x-2 items-center">

                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                      {(activeSection === "hackerrank" || activeSection === "both") && hackerrankEnabled && (
                        <div className={`transition-opacity duration-500  ${isPublished ? 'opacity-50 pointer-events-none' : 'opacity-100 cursor-pointer'}`} onClick={() => {
                          setActiveSection("hackerrank")
                        }}>
                          <div className={`items-center flex flex-col bg-[#f0f4fc] rounded-md p-4 border-[1px] shadow-md transition-all ${hackerrankComplete ? 'border-[#148EFF] ring-1 ring-[#148EFF]' : 'border-[#d2d4da]'}`}>
                            <div className="flex flex-col gap-1 items-center">

                              <img src={HackerRankLogo} className="bg-black p-2 w-60"></img>
                              <p className="font-semibold flex items-center gap-2">
                                HackerRank Assessment
                                {hackerrankComplete && <span className="text-green-600 text-sm font-bold">✓</span>}
                              </p>
                            </div>
                            <div className="flex mt-2 items-start space-x-10">
                              <div className="flex space-x-2 items-center">


                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                      {(activeSection === "coderbyte" || activeSection === "both") && coderbyteEnabled && (
                        <div className={`transition-opacity duration-500  ${isPublished ? 'opacity-50 pointer-events-none' : 'opacity-100 cursor-pointer'}`} onClick={() => {
                          setActiveSection("coderbyte")
                        }}>
                          <div className={`items-center flex flex-col bg-[#f0f4fc] rounded-md p-4 border-[1px] shadow-md transition-all ${coderbyteComplete ? 'border-[#148EFF] ring-1 ring-[#148EFF]' : 'border-[#d2d4da]'}`}>
                            <div className="flex flex-col gap-1 items-center">

                              <img src={CoderbyteLogo} className="w-60 h-[42px] object-contain"></img>
                              <p className="font-semibold flex items-center gap-2">
                                Coderbyte Assessment
                                {coderbyteComplete && <span className="text-green-600 text-sm font-bold">✓</span>}
                              </p>
                            </div>
                            <div className="flex mt-2 items-start space-x-10">
                              <div className="flex space-x-2 items-center">


                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                    {activeSection === "ai" && (
                      <div className="rounded-xl border mt-6 shadow-lg">
                        <div className="bg-[#f0f4fc] rounded-t-xl px-4 py-3 flex justify-between gap-3">
                          <p className="text-lg font-semibold text-black">AI Interview Settings</p>
                          <button
                            onClick={() => {
                              setActiveSection("both");
                              setIncludeAiQuestions(false)
                              setManualTrigger(false)
                              setLanguage("EN")
                              jdSumGeneration();
                              setSkip(true)
                            }}
                            className={`px-6 py-2 rounded-xl bg-[#148EFF] text-white disabled:opacity-50`}
                            disabled={isPublished}
                          >
                            Skip Assessment
                          </button>
                        </div>

                        <div className="p-6 space-y-8">
                          {/* Trigger */}
                          {manualTriggerEnabled && (<div>
                            <p className="font-semibold text-gray-700">
                              Trigger AI Interview <span className="text-red-500">*</span>
                            </p>
                            <div className="flex mt-3 gap-4">
                              <button
                                className={`px-4 py-2 rounded-md border transition ${manualtrigger ? "bg-[#148EFF] text-white" : "bg-white text-black"}`}
                                onClick={() => setManualTrigger(true)}
                                disabled={skipTech || isPublished}
                              >
                                Manual Trigger
                              </button>
                              <button
                                className={`px-4 py-2 rounded-xl border transition ${!manualtrigger ? "bg-[#148EFF] text-white" : "bg-white text-black"}`}
                                onClick={() => setManualTrigger(false)}
                                disabled={isPublished}
                              >
                                Resume Threshold
                              </button>

                              {!manualtrigger && <div className="w-1/3 relative ml-3">
                                <Slider value={trigger} setValue={setTrigger} />
                                <div className="absolute -bottom-1 left-1/2 transform -translate-x-2/3 w-full">
                                  <p className="text-center text-sm font-medium">Resume Compatibility Threshold</p>
                                </div>
                              </div>}
                            </div>
                          </div>)}

                          {/* Language */}
                          <div>
                            <p className="font-semibold text-gray-700">
                              Interview language <span className="text-red-500">*</span>
                            </p>
                            <div className="flex mt-3 gap-4">
                              {getLanguageOptions(companyCountryCode).map((lang) => (
                                <button
                                  key={lang.value}
                                  className={`px-4 py-2 rounded-md border transition ${language === lang.value ? "bg-[#148EFF] text-white" : "bg-white text-black"}`}
                                  onClick={() => setLanguage(lang.value)}
                                  disabled={skipTech || isPublished}
                                >
                                  {lang.label}
                                </button>
                              ))}
                            </div>
                          </div>

                          {/* Technical Assessment */}
                          <div>
                            <div className="flex items-center justify-between">
                              <p className="font-semibold text-gray-700">Assess on Technical Competency</p>
                            </div>

                            <div className="mt-4 flex flex-wrap gap-4 items-center">
                              {/* Add Question Button */}
                              <button
                                className={`px-4 py-2 rounded-md ${skipTech ? "bg-gray-300 text-gray-500" : "bg-[#148EFF] text-white"
                                  }`}
                                onClick={() => {
                                  if (!skipTech && questions.length === 0) {
                                    setQuestions([
                                      { question: "", answer: "" },
                                      { question: "", answer: "" },
                                    ]);
                                  }
                                }}
                                disabled={skipTech || isPublished}
                              >
                                Add Technical Question
                              </button>


                              {/* Generate with AI Button */}
                              <button
                                onClick={() => {
                                  if (!skipTech) {
                                    setNumQuestions(2);
                                    setShowAIDropdown(true);
                                    setGenAiLoader(true);
                                    genAiQUestions(2);
                                  }
                                }}
                                disabled={skipTech || isPublished}
                                className={`font-semibold rounded-xl p-[0.15rem] w-fit
        ${skipTech ? "bg-gray-300" : "bg-gradient-to-r from-[#F7284AA3] via-[#7366FFCC] to-[#0DCD94CC]"}
      `}
                              >
                                <div
                                  className={`h-full p-2 rounded-lg w-full 
          ${skipTech ? "bg-gray-200" : "bg-white"}
        `}
                                >
                                  <p
                                    className={`text-center 
            ${skipTech
                                        ? "text-gray-500"
                                        : "bg-gradient-to-r brightness-110 text-transparent bg-clip-text from-[#F7284AA3] via-[#7366FFCC] to-[#0DCD94CC]"
                                      }`}
                                  >
                                    Generate using AI
                                  </p>
                                </div>
                              </button>

                              {/* Skip Technical Assessment Button */}
                              <button
                                className="px-4 py-2 rounded-md border border-blue-500 text-blue-500 bg-white text-sm disabled:opacity-50"
                                onClick={() => setShowConfirm(true)}
                                disabled={isPublished}
                              >
                                Skip Technical Assessment
                              </button>
                            </div>

                            {/* Question Count Dropdown */}
                            {showAIDropdown && !skipTech && (
                              <div className="flex items-center gap-2 mt-3">
                                <label className="text-sm">Select number of questions</label>
                                <select
                                  value={numQuestions}
                                  onChange={(e) => {
                                    const selected = parseInt(e.target.value);
                                    setNumQuestions(selected);
                                    setGenAiLoader(true);
                                    genAiQUestions(selected);
                                  }}
                                  className="border p-1 rounded-md text-sm"
                                  disabled={genAiLoader || isPublished}
                                >
                                  {[2, 3, 4, 5].map((num) => (
                                    <option key={num} value={num} disabled={genAiLoader || isPublished}>{num}</option>
                                  ))}
                                </select>
                                {genAiLoader && (
                                  <TailSpin height="20" width="20" color="gray" />
                                )}
                              </div>
                            )}

                            {/* Render Questions */}
                            {questions.length > 0 && (
                              <>
                                <div className="mt-6 space-y-4">
                                  {questions.map((q, index) => (
                                    <div key={index} className="space-y-2">
                                      <div className="flex justify-between items-center">
                                        <p className="font-medium">Question {index + 1}</p>
                                        <button onClick={() => deleteByIndex(index)} disabled={isPublished}>
                                          <img src={delete_black} alt="Delete" className="w-4" />
                                        </button>
                                      </div>

                                      <input
                                        type="text"
                                        name="question"
                                        value={q.question}
                                        onChange={(e) => handleChange(index, e)}
                                        className="border p-2 rounded w-full"
                                        disabled={isPublished}
                                      />

                                      {q.question.length > 0 && q.question.trim().split(/\s+/).length < 5 && (
                                        <p className="text-red-500 text-sm">Question should have at least 5 words</p>
                                      )}
                                    </div>
                                  ))}
                                </div>
                                <button
                                  className="text-cyan-600 w-full text-left font-semibold mt-3 disabled:text-gray-400"
                                  onClick={() => {
                                    if (questions.length < 6) {
                                      setQuestions([
                                        ...questions,
                                        {
                                          question: "",
                                          answer: "",
                                        },
                                      ]);
                                    }
                                  }}
                                  disabled={questions.length >= 6 || isPublished}
                                >
                                  + Add Another Question
                                </button>

                              </>
                            )}
                          </div>


                          {/* Score Inputs */}
                          <div className="space-y-4">
                            <div className="flex items-center gap-3">
                              <p className="font-semibold">Assign skills weightage</p>
                              <button onClick={() => setOpenPopup(true)}>
                                <FaInfoCircle />
                              </button>
                            </div>

                            <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
                              {[
                                { label: "Resume compatibility", value: resCom, setValue: setResCom },
                                { label: "Employability skills", value: intScore, setValue: setIntScore },
                                ...(questions.length > 0 ? [{ label: "Technical score", value: techWeight, setValue: setTechWeight }] : []),
                                { label: "Voice analysis score", value: vaScore, setValue: setVAScore },
                              ].map((item, idx) => (
                                <div key={idx}>
                                  <p className="font-semibold">{item.label}</p>
                                  <input
                                    value={item.value}
                                    onChange={(e) => {
                                      const val = e.target.value.replace(/,/g, "");
                                      if (onlyContainsNumbers(val)) item.setValue(Number(val));
                                    }}
                                    className="w-full border px-2 py-1 rounded-md mt-2"
                                    disabled={isPublished}
                                  />
                                </div>
                              ))}

                              <div>
                                <p className="font-semibold">Total score</p>
                                <div className="w-full border px-2 py-1 rounded-md mt-2">
                                  {isNaN(total) ? 0 : total}
                                </div>
                              </div>
                            </div>


                          </div>

                          {/* Save Settings */}
                          <div className="pt-4 flex justify-end">
                            <button
                              className={`px-6 py-2 rounded-md text-white 
    ${(total !== 100 || isPublished) ? 'bg-gray-400 cursor-not-allowed' : 'bg-[#148EFF] hover:bg-[#148EFF]'}`}
                              disabled={total !== 100 || submitLoader || isPublished}
                              onClick={() => {
                                handleSubmit()
                              }}
                            >
                              {submitLoader ? (
                                <TailSpin color="white" height={20} width={20} />
                              ) : (
                                "Save Settings"
                              )}
                            </button>

                          </div>


                        </div>
                      </div>
                    )}

                    {showConfirm && (<div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                      <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md">
                        <h2 className="text-xl font-semibold mb-4">Delete All Technical Questions?</h2>
                        <p className="mb-6 text-gray-700">Are you sure you want to delete all technical questions and skip technical assessment?</p>
                        <div className="flex justify-end space-x-4">
                          <button
                            onClick={() => handleConfirmDeleteAll(false)}
                            className="px-4 py-2 bg-gray-300 text-gray-800 rounded hover:bg-gray-400"
                          >
                            Cancel
                          </button>
                          <button
                            onClick={() => handleConfirmDeleteAll(true)}
                            className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
                          >
                            Confirm
                          </button>
                        </div>
                      </div>
                    </div>)}


                    {activeSection === "hackerrank" && (
                      <div className="rounded-xl border p-6 flex flex-col gap-4 mt-4">
                        <p className="text-lg font-semibold text-gray-800">HackerRank Assesment Settings</p>

                        {/* Test Selection */}
                        <div className="w-full bg-white  flex gap-4">
                          {/* HackerRank Test Selection */}
                          <div className="flex flex-col w-[40%]">
                            <div className="mb-2 text-sm font-medium text-gray-700 flex gap-2">
                              <p> Select HackerRank Test</p>
                              {!isPublished && (
                                <button
                                  className="text-blue-500  rounded-md w-full sm:w-auto "
                                  onClick={() => {
                                    toast.warning(
                                      "This job is saved as a draft. You’ll now be redirected to the HackerRank portal.",
                                      {
                                        position: "top-center",
                                        autoClose: true,
                                        closeOnClick: true,
                                        closeButton: true,
                                      }
                                    );

                                    setTimeout(() => {
                                      window.open("https://www.hackerrank.com/work/tests", "_blank");
                                      window.history.back();
                                    }, 2000);
                                  }}
                                >
                                  + Create New Test
                                </button>
                              )}
                            </div>
                            <Select
                              options={testOptions}
                              value={selectedOption}
                              onChange={(option) => setSelectedOption(option)}
                              placeholder="Choose a test"
                              isSearchable
                              className="w-full"
                              isDisabled={isPublished}
                            />
                          </div>

                          {/* Date Range and Create Button */}
                          <div className="flex flex-col sm:flex-row   w-[60%]">
                            <div className="w-full ">
                              <label className="mb-2 text-sm font-semibold text-gray-700 block">Invitation Validity</label>
                              <div
                                className={`custom-placeholder flex items-center  rounded w-fit ${dateFocused ? "border-[#8f94a1] border-2" : "border-[#D2D4DA] border"
                                  }`}
                              >
                                <span
                                  className={`${dateFocused ? "bg-[#8f94a1]" : "bg-[#D2D4DA]"
                                    } flex items-center rounded-l-sm w-fit h-9 px-2`}
                                >
                                  <MdOutlineDateRange
                                    className={`${dateFocused ? "text-white" : "text-[#8f94a1]"
                                      } w-5 h-5`}
                                  />
                                </span>

                                <DatePicker
                                  selected={inviteValidFrom}
                                  onFocus={() => setDateFocused(true)}
                                  onBlur={() => setDateFocused(false)}
                                  onChange={(date) => {
                                    setInviteValidFrom(date);
                                    if (!inviteValidTo || date > inviteValidTo) {
                                      setInviteValidTo(null);
                                    }
                                  }}
                                  selectsStart
                                  isClearable={!isPublished}
                                  startDate={inviteValidFrom}
                                  endDate={inviteValidTo}
                                  dateFormat="dd-MM-yy"
                                  className={`${dateFocused ? "border-[#8f94a1] border-r-2" : "border-[#D2D4DA] border-r"
                                    } ${dateFocused || inviteValidFrom || inviteValidTo ? "font-semibold" : ""
                                    } w-1/2 text-[#8f94a1] text-[14px] z-50 h-9 px-2 `}
                                  placeholderText="From"
                                  minDate={new Date()}
                                  disabled={isPublished}
                                />

                                <DatePicker
                                  selected={inviteValidTo}
                                  onFocus={() => setDateFocused(true)}
                                  onBlur={() => setDateFocused(false)}
                                  onChange={(date) => setInviteValidTo(date)}
                                  selectsEnd
                                  isClearable={!isPublished}
                                  startDate={inviteValidFrom}
                                  endDate={inviteValidTo}
                                  dateFormat="dd-MM-yy"
                                  minDate={inviteValidFrom || new Date()}
                                  className={`${dateFocused ? "border-[#8f94a1]" : "border-[#D2D4DA]"
                                    } ${dateFocused || inviteValidFrom || inviteValidTo ? "font-semibold" : ""
                                    } w-full rounded-r text-[#8f94a1] text-[14px] z-50 h-9 px-2`}
                                  placeholderText="To"
                                  disabled={!inviteValidFrom || isPublished}
                                />
                              </div>
                            </div>

                            {/* Create Test Button
    <div className="w-full flex items-end">
      <button
        className="bg-[#148EFF] text-white px-4 py-2 mt-1 rounded-md w-full sm:w-auto"
        onClick={() => {
          toast.warning(
            "This job is saved as a draft. You’ll now be redirected to the HackerRank portal.",
            {
              position: "top-center",
              autoClose: true,
              closeOnClick: true,
              closeButton: true,
            }
          );

          setTimeout(() => {
            window.open("https://www.hackerrank.com/work/tests", "_blank");
            window.history.back();
          }, 2000);
        }}
      >
        Create New Test
      </button>
    </div> */}
                          </div>
                        </div>


                        <hr className="bg-gray-200 h-[0.08rem]"></hr>
                        <div className="">

                          <div className="flex mt-2 justify-end gap-2">
                            {hackerrankComplete && (
                              <button
                                className="bg-red-600 text-white p-2 rounded-md hover:bg-red-700 disabled:opacity-50"
                                disabled={isPublished}
                                onClick={() => { handleRemoveHackerrank(); }}
                              >
                                Remove Assessment
                              </button>
                            )}
                            <button className="bg-gray-500 text-white p-2 rounded-md" onClick={() => { setActiveSection("both"); }}>
                              Cancel
                            </button>
                            <button
                              className="bg-[#148EFF] text-white p-2 rounded-md disabled:opacity-50"
                              disabled={isPublished}
                              onClick={() => { handleHackerrankSettingsComplete(); }}
                            >
                              Save Settings
                            </button>
                          </div>
                        </div>
                      </div>
                    )}

                    {activeSection === "coderbyte" && (
                      <div className="rounded-xl border p-6 flex flex-col gap-4 mt-4">
                        <p className="text-lg font-semibold text-gray-800">Coderbyte Assessment Settings</p>

                        {/* Test Selection */}
                        <div className="w-full bg-white flex gap-4">
                          {/* Coderbyte Test Selection */}
                          <div className="flex flex-col w-[40%]">
                            <div className="mb-2 text-sm font-medium text-gray-700 flex gap-2">
                              <p>Select Coderbyte Test</p>
                              {!isPublished && (
                                <button
                                  className="text-blue-500 rounded-md w-full sm:w-auto "
                                  onClick={() => {
                                    toast.warning(
                                      "This job is saved as a draft. You’ll now be redirected to the Coderbyte portal.",
                                      {
                                        position: "top-center",
                                        autoClose: true,
                                        closeOnClick: true,
                                        closeButton: true,
                                      }
                                    );

                                    setTimeout(() => {
                                      window.open("https://coderbyte.com/organization/assessments", "_blank");
                                      window.history.back();
                                    }, 2000);
                                  }}
                                >
                                  + Create New Test
                                </button>
                              )}
                            </div>
                            <Select
                              options={coderbyteOptions}
                              value={selectedCoderbyteOption}
                              onChange={(option) => setSelectedCoderbyteOption(option)}
                              placeholder="Choose a test"
                              isSearchable
                              className="w-full"
                              noOptionsMessage={() => coderbyteError || "No options"}
                              isDisabled={isPublished}
                            />
                          </div>

                          {/* Date Range and Save Button */}
                          <div className="flex flex-col sm:flex-row w-[60%]">
                            <div className="w-full ">
                              <label className="mb-2 text-sm font-semibold text-gray-700 block">Invitation Validity</label>
                              <div
                                className={`custom-placeholder flex items-center rounded w-fit ${dateFocused ? "border-[#8f94a1] border-2" : "border-[#D2D4DA] border"
                                  }`}
                              >
                                <span
                                  className={`${dateFocused ? "bg-[#8f94a1]" : "bg-[#D2D4DA]"
                                    } flex items-center rounded-l-sm w-fit h-9 px-2`}
                                >
                                  <MdOutlineDateRange
                                    className={`${dateFocused ? "text-white" : "text-[#8f94a1]"
                                      } w-5 h-5`}
                                  />
                                </span>

                                <DatePicker
                                  selected={coderbyteInviteValidFrom}
                                  onFocus={() => setDateFocused(true)}
                                  onBlur={() => setDateFocused(false)}
                                  onChange={(date) => {
                                    setCoderbyteInviteValidFrom(date);
                                    if (!coderbyteInviteValidTo || date > coderbyteInviteValidTo) {
                                      setCoderbyteInviteValidTo(null);
                                    }
                                  }}
                                  selectsStart
                                  isClearable={!isPublished}
                                  startDate={coderbyteInviteValidFrom}
                                  endDate={coderbyteInviteValidTo}
                                  dateFormat="dd-MM-yy"
                                  className={`${dateFocused ? "border-[#8f94a1] border-r-2" : "border-[#D2D4DA] border-r"
                                    } ${dateFocused || coderbyteInviteValidFrom || coderbyteInviteValidTo ? "font-semibold" : ""
                                    } w-1/2 text-[#8f94a1] text-[14px] z-50 h-9 px-2 `}
                                  placeholderText="From"
                                  minDate={new Date()}
                                  disabled={isPublished}
                                />

                                <DatePicker
                                  selected={coderbyteInviteValidTo}
                                  onFocus={() => setDateFocused(true)}
                                  onBlur={() => setDateFocused(false)}
                                  onChange={(date) => setCoderbyteInviteValidTo(date)}
                                  selectsEnd
                                  isClearable={!isPublished}
                                  startDate={coderbyteInviteValidFrom}
                                  endDate={coderbyteInviteValidTo}
                                  dateFormat="dd-MM-yy"
                                  minDate={coderbyteInviteValidFrom || new Date()}
                                  className={`${dateFocused ? "border-[#8f94a1]" : "border-[#D2D4DA]"
                                    } ${dateFocused || coderbyteInviteValidFrom || coderbyteInviteValidTo ? "font-semibold" : ""
                                    } w-full rounded-r text-[#8f94a1] text-[14px] z-50 h-9 px-2`}
                                  placeholderText="To"
                                  disabled={!coderbyteInviteValidFrom || isPublished}
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        <hr className="bg-gray-200 h-[0.08rem]"></hr>
                        <div className="flex mt-2 justify-end gap-2">
                          {coderbyteComplete && (
                            <button
                              className="bg-red-600 text-white p-2 rounded-md hover:bg-red-700 disabled:opacity-50"
                              disabled={isPublished}
                              onClick={() => { handleRemoveCoderbyte(); }}
                            >
                              Remove Assessment
                            </button>
                          )}
                          <button className="bg-gray-500 text-white p-2 rounded-md" onClick={() => { setActiveSection("both"); }}>
                            Cancel
                          </button>
                          <button
                            className="bg-[#148EFF] text-white p-2 rounded-md disabled:opacity-50"
                            disabled={isPublished}
                            onClick={() => { handleCoderbyteSettingsComplete(); }}
                          >
                            Save Settings
                          </button>
                        </div>
                      </div>
                    )}

                  </div>
                </div>
              </div>
            )
          }

          {tab == 2 && (
            <div className=" rounded-xl ">

              <div className="bg-[#E9EBFA] mt-5 h-[0.1rem] w-full"></div>
              <div className="flex space-x-6  px-4 py-5 items-center justify-end w-full">
                <button
                  className="px-10 py-2 bg-white border border-[#148EFF] text-[#148EFF] rounded-xl"
                  onClick={() => {
                    setTab(1);
                  }}
                >
                  Back
                </button>


                <button
                  onClick={() => {
                    if (includeAiQuestions) {
                      patchSubmit(true);
                    } else {
                      jdSumGeneration();
                      setTab(3);
                    }
                  }}
                  className={
                    includeAiQuestions || hackerrankComplete || coderbyteComplete || skip
                      ? "px-6 py-2 text-white bg-[#148EFF] rounded-xl"
                      : "px-6 py-2 text-white bg-gray-400 rounded-xl"
                  }
                  disabled={!(includeAiQuestions || hackerrankComplete || coderbyteComplete || skip)}
                >
                  Save & Next
                </button>

              </div>
            </div>
          )}



          {tab == 3 && (
            <div className="mb-10">
              <div className="p-5  rounded-xl ">
                <div className="flex flex-col space-y-4">
                  <div className="flex w-full ">
                    <p className="font-semibold w-1/2">
                      Job title:{" "}
                      <span className="text-[#8F94A1] font-normal">
                        {title}
                      </span>
                    </p>
                    <p className="font-semibold w-1/2">
                      Job type:{" "}
                      <span className="text-[#8F94A1] font-normal">
                        {jtype}
                      </span>
                    </p>
                  </div>
                  <div className="flex w-full ">
                    <p className="font-semibold w-1/2">
                      No of openings:{" "}
                      <span className="text-[#8F94A1] font-normal">
                        {noOfPositions}
                      </span>
                    </p>
                    <p className="font-semibold w-1/2">
                      Department:{" "}
                      <span className="text-[#8F94A1] font-normal">
                        {department}
                      </span>
                    </p>
                  </div>

                  {grade && (
                    <div className="flex w-full ">
                      <p className="font-semibold w-1/2">
                        Grade:{" "}
                        <span className="text-[#8F94A1] font-normal">
                          {selectedGradeLabel}
                        </span>
                      </p>
                    </div>
                  )}

                  <div className="flex w-full ">
                    {/* <p className="font-semibold w-1/2">
                      Last date to apply:{" "}
                      <span className="text-[#8F94A1] font-normal">
                        {lda.split("-")[2]}-{lda.split("-")[1]}-
                        {lda.split("-")[0]}
                      </span>
                    </p> */}
                    <p className="font-semibold w-1/2">
                       Annual Salary:{" "}
                      <span className="text-[#8F94A1] font-normal">
                        {getCurrencySymbol(companyCountryCode)} {formatSalary(salaryFrom, companyCountryCode)} - {getCurrencySymbol(companyCountryCode)} {formatSalary(salaryTo, companyCountryCode)}
                      </span>
                    </p>
                    <p className="font-semibold w-1/2">
                      Experience:{" "}
                      <span className="text-[#8F94A1] font-normal">
                        {experience} - {maxExp} years
                      </span>
                    </p>
                  </div>
                  <div className="flex w-full ">
                    <p className="font-semibold w-1/2">
                      Location:{" "}
                      <span className="text-[#8F94A1] font-normal">
                        {locationValues.toString()}
                      </span>
                    </p>
                    <p className="font-semibold w-1/2">
                      Work style:{" "}
                      <span className="text-[#8F94A1] font-normal">{ws}</span>
                    </p>
                  </div>

                  {fromAcfl && (
                    <div className="flex w-full ">
                      <p className="font-semibold w-1/2">
                        Type of Position:{" "}
                        <span className="text-[#8F94A1] font-normal">{positionType}</span>
                      </p>
                      {positionType === "New" && (
                        <p className="font-semibold w-1/2">
                          Comments:{" "}
                          <span className="text-[#8F94A1] font-normal">{newPositionComments}</span>
                        </p>
                      )}
                    </div>
                  )}
                  {fromAcfl && positionType === "Replacement" && (
                    <div className="w-full">
                      <div className="flex w-full">
                        <p className="font-semibold w-1/2">
                          Replacement Name:{" "}
                          <span className="text-[#8F94A1] font-normal">{replacementEmployeeName}</span>
                        </p>
                        <p className="font-semibold w-1/2">
                          Replacement Code:{" "}
                          <span className="text-[#8F94A1] font-normal">{replacementEmployeeCode}</span>
                        </p>
                      </div>
                      <div className="flex w-full mt-3">
                        <p className="font-semibold w-1/2">
                          Replacement Location:{" "}
                          <span className="text-[#8F94A1] font-normal">{replacementEmployeeLocation}</span>
                        </p>
                        <p className="font-semibold w-1/2">
                          Replacement Designation:{" "}
                          <span className="text-[#8F94A1] font-normal">{replacementEmployeeDesignation}</span>
                        </p>
                      </div>
                    </div>
                  )}

                  {fromAcfl && (
                    <>
                      <div className="flex w-full ">
                        <p className="font-semibold w-1/2">
                          Min. Salary (Same Grade):{" "}
                          <span className="text-[#8F94A1] font-normal">{getCurrencySymbol(companyCountryCode)} {formatSalary(minSalarySameGrade, companyCountryCode)}</span>
                        </p>
                        <p className="font-semibold w-1/2">
                          Max. Salary (Same Grade):{" "}
                          <span className="text-[#8F94A1] font-normal">{getCurrencySymbol(companyCountryCode)} {formatSalary(maxSalarySameGrade, companyCountryCode)}</span>
                        </p>
                      </div>
                      <div className="flex w-full ">
                        <p className="font-semibold w-1/2">
                          Total Active Employees (Same Grade):{" "}
                          <span className="text-[#8F94A1] font-normal">{activeEmployeesSameGrade}</span>
                        </p>
                      </div>
                      <div className="flex w-full ">
                        <p className="font-semibold w-1/2">
                          Maximum Date of Birth:{" "}
                          <span className="text-[#8F94A1] font-normal">{minDob}</span>
                        </p>
                        <p className="font-semibold w-1/2">
                          Minimum Education:{" "}
                          <span className="text-[#8F94A1] font-normal">{minEducation}</span>
                        </p>
                      </div>
                    </>
                  )}

                  <div>
                    <p className="mb-2 font-semibold">Job description:</p>
                    <ReactQuill
                      value={description}
                      readOnly={true}
                      theme="bubble"
                    ></ReactQuill>
                    {/* <div className="text-[#8F94A1] " dangerouslySetInnerHTML={{__html: description}}></div> */}
                  </div>

                  <p className="mb-2 font-semibold">
                    AI Interview:{" "}
                    <span className="text-[#8F94A1] font-normal">
                      {includeAiQuestions ? "Yes" : "No"}
                    </span>
                  </p>

                  {includeAiQuestions && <div className="flex w-full ">
                    <p className="font-semibold w-1/2">
                      Trigger AI Interview:{" "}
                      <span className="text-[#8F94A1] font-normal">
                        {!manualtrigger ? "Resume Compatibility Score" : "Manual Trigger"}
                      </span>
                    </p>
                    {!manualtrigger && <p className="font-semibold w-1/2">
                      Threshold:{" "}
                      <span className="text-[#8F94A1] font-normal">{trigger}</span>
                    </p>}
                  </div>}

                  {
                    hasAiCalling && <div className="flex w-full ">
                      <p className="font-semibold w-1/2">
                        AI Calling:{" "}
                        <span className="text-[#8F94A1] font-normal">
                          {hasAiCalling ? "Yes" : "No"}
                        </span>
                      </p>
                    </div>
                  }

                  {includeAiQuestions && (
                    <>
                      <p className="mb-2 font-semibold">Skills weightage:</p>
                      <div className="flex  space-x-5">
                        <p className="font-semibold w-1/2">
                          Resume compatibility score:{" "}
                          <span className="text-[#8F94A1] font-normal">{resCom}</span>
                        </p>
                        <p className="font-semibold w-1/2">
                          Employability skills score:{" "}
                          <span className="text-[#8F94A1] font-normal">{intScore}</span>
                        </p>
                        <p className="font-semibold w-1/2">
                          Voice analysis score:{" "}
                          <span className="text-[#8F94A1] font-normal">{vaScore}</span>
                        </p>
                        {techWeight > 0 && (
                          <p className="font-semibold w-1/2">
                            Technical Score:{" "}
                            <span className="text-[#8F94A1] font-normal">{techWeight}</span>
                          </p>
                        )}
                      </div>
                    </>
                  )}

                  {questions.length > 0 && (
                    <div className="mt-6">
                      <p className="mb-2 font-semibold">Technical Questions:</p>
                      <ul className="list-disc pl-5 space-y-2 text-[#8F94A1]">
                        {questions.map((q, index) => (
                          <li key={index}>
                            <span className="font-medium">Q{index + 1}:</span> {q.question}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}

                  {(() => {
                    const configuredAssessments = [
                      {
                        enabled: hackerrankComplete,
                        provider: "HackerRank",
                        name: selectedOption?.label,
                        validityFrom: inviteValidFrom,
                        validityTo: inviteValidTo,
                      },
                      {
                        enabled: coderbyteComplete,
                        provider: "Coderbyte",
                        name: selectedCoderbyteOption?.label,
                        validityFrom: coderbyteInviteValidFrom,
                        validityTo: coderbyteInviteValidTo,
                      },
                    ].filter((a) => a.enabled);

                    if (configuredAssessments.length === 0) return null;

                    return configuredAssessments.map((assessment) => (
                      <div key={assessment.provider} className="mt-6">
                        <p className="mb-2 font-semibold">
                          {assessment.provider} Assessment:{" "}
                          <span className="text-[#8F94A1] font-normal">Yes</span>
                        </p>
                        <div className="flex w-full">
                          <p className="font-semibold w-1/2">
                            Assessment Name:{" "}
                            <span className="text-[#8F94A1] font-normal">
                              {assessment.name || "-"}
                            </span>
                          </p>
                          <p className="font-semibold w-1/2">
                            Validity:{" "}
                            <span className="text-[#8F94A1] font-normal">
                              {assessment.validityFrom && assessment.validityTo
                                ? `${formatDateToShortMonth(assessment.validityFrom)} to ${formatDateToShortMonth(assessment.validityTo)}`
                                : "-"}
                            </span>
                          </p>
                        </div>
                      </div>
                    ));
                  })()}

                </div>
              </div>
              <div className="bg-[#E9EBFA] h-[0.1rem] w-full"></div>
              <div className="flex space-x-6   px-4 py-5 items-center justify-end w-full">
                <button
                  className="px-10 py-2 bg-white border border-[#148EFF] text-[#575b5e] rounded-xl"
                  onClick={() => {
                    setTab(2);
                  }}
                >
                  Back
                </button>

                <div className="relative" ref={dropdownRef}>
                  <button
                    className={
                      !open
                        ? "py-2 h-full  bg-[#0DCD94] text-white px-10 rounded-lg"
                        : "py-2 h-full  bg-[#0DCD94] text-white px-10 rounded-t-lg"
                    }
                    onClick={() => {
                      setOpen(!open);
                    }}
                  >
                    <div className="flex items-center justify-between" >
                      {hasApproverFlow ? "Save or Request Approval" : "Save or Publish"}
                      <img src={arrow} className="-rotate-90 mx-4 h-2"></img>
                    </div>
                  </button>
                  {open && (
                    <div className="flex flex-col bg-[#3FBA95] absolute w-full text-white rounded-b-lg" >
                      <button
                        onClick={() => {
                          JobCreate()
                        }}
                      >
                        <div className="flex items-center space-x-2 py-3 px-3">
                          <img src={Paper_negative} className="h-6"></img>
                          <p>Save as a template</p>
                        </div>
                      </button>
                      <button
                        onClick={() => {
                          if (hasApproverFlow) {
                            setOpen(false);
                            setShowApprovalModal(true);
                          } else {
                            jobSubmit("publish");
                          }
                        }}
                      >
                        <div className="flex items-center space-x-2 py-3 px-3">
                          <img src={Paper_plus} className="h-6"></img>
                          <p>{hasApproverFlow ? "Request approval" : "Publish job"}</p>
                        </div>
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Job Approval Modal */}
      {showApprovalModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-[500px] max-w-[90%]">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-semibold">Send Job for Approval</h2>
              <button
                onClick={() => {
                  setShowApprovalModal(false);
                  setSelectedApprover(null);
                }}
                className="text-gray-500 hover:text-gray-700"
              >
                <IoMdClose size={24} />
              </button>
            </div>

            <div className="mb-6">
              <label className="block text-sm font-medium mb-2">
                Select Approver <span className="text-red-500">*</span>
              </label>
              <Select
                options={jobApprovers}
                value={selectedApprover}
                onChange={setSelectedApprover}
                placeholder="Choose an approver..."
                isClearable
                styles={{
                  control: (provided, state) => ({
                    ...provided,
                    borderColor: state.isFocused ? '#148EFF' : '#e5e7eb',
                    boxShadow: state.isFocused ? '0 0 0 1px #148EFF' : 'none',
                    '&:hover': {
                      borderColor: '#148EFF',
                    },
                  }),
                }}
              />
              {jobApprovers.length === 0 && (
                <p className="text-sm text-red-500 mt-2">
                  No job approvers available. Please ensure users have job approver permissions.
                </p>
              )}
            </div>

            <div className="flex justify-end space-x-3">
              <button
                onClick={() => {
                  setShowApprovalModal(false);
                  setSelectedApprover(null);
                }}
                className="px-6 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50"
              >
                Cancel
              </button>
              <button
                onClick={sendJobForApproval}
                disabled={!selectedApprover || approvalLoading}
                className={`px-6 py-2 rounded-lg text-white ${!selectedApprover || approvalLoading
                  ? 'bg-gray-400 cursor-not-allowed'
                  : 'bg-[#148EFF] hover:bg-[#1270CC]'
                  }`}
              >
                {approvalLoading ? (
                  <div className="flex items-center">
                    <TailSpin height="20" width="20" color="white" />
                    <span className="ml-2">Sending...</span>
                  </div>
                ) : (
                  'Send for Approval'
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      <Copyright />
    </div>
  );
};

export default NewJobs;
